<style scoped>
    .swiper{
        --swiper-navigation-color: #fff;/* 单独设置按钮颜色 */
        --swiper-navigation-size: 1.8rem;/* 设置按钮大小 */
    }
    .text-red{
        color:#c90013;
    }
    .amount.active{
        animation: amount .5s ease infinite alternate;
    }
    .hover-bg-opacity-50:hover{
        --bs-bg-opacity: 0.5;
    }
    #fullPearl{
        transition: left .5s ease;
    }
    .big-scale-small{
        animation: big-scale-small .2s ease-in .2s;
    }
    .layer-absolute-radius::after{
        border-radius: .5rem;
    }
    .layer-absolute-start-radius::after{
        border-top-left-radius: .5rem;
        border-bottom-left-radius: .5rem;
    }
    .layer-absolute-end-radius::after{
        border-top-right-radius: .5rem;
        border-bottom-right-radius: .5rem;
    }
    @keyframes big-scale-small{
        0%{
            font-size: 4rem;
        }
        100%{
            font-size: 1.5rem;
        }
    }
    @keyframes amount {
        0% {
            box-shadow: rgb(249,252,0) 0 0 .2rem .2rem;
        }
        100% {
            box-shadow: rgba(249,252,255) 0 0 .2rem .2rem;
        }
    }
    .coruscate{
        animation: coruscate .5s ease infinite alternate;
    }
	@keyframes coruscate {
        0% {
            background: rgba(25,135,84,1);
        }
        100% {
            background: rgba(13,202,240);
        }
    }
    .scale-2{
        animation:scale2 .12s ease-out;
    }
    @keyframes scale2 {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(1.5);
        }
    }
    .untransition{
        transition: none !important;
    }
    
    @media (min-width:576px) {
        .tel-video-h{
            /* 26.917rem */
            height: 23.211rem;
        }
    }
    @media (min-width:768px) {
        .tel-video-h{
            height: 25.523rem;
        }
    }
    @media (min-width: 992px){
        .tel-video-h{
            height: 27.072rem;
        }
    }
    @media (min-width: 1200px){
        .tel-video-h{
            height: 27.194rem;
        }
    }
    @media (min-width: 1400px){
        .tel-video-h{
            height: 28.656rem;
        }
    }
</style>
<style>
    .task-3_5rem>.direction{
        width: 3.5rem;
    }
    .ms--_5rem{
        margin-left: -0.5rem !important;
    }
    .me--_5rem{
        margin-right: -0.5rem !important;
    }
</style>
<template>
    <div class="d-flex flex-column h-100">
        <!-- 横向导航 -->
        <navbar :class="[isMultiple?'':'d-sm-none']" class="order-first d-flex flex-column" :has-chat-msg="hasChatMsg" :is-page-ready="isPageReady" :is-fullscreen="isFullscreen" ></navbar>
        <!-- 主内容 -->
        <div class="d-flex flex-grow-1 h-0 flex-column" :class="[(gameModel==GAME_MODEL.normal)?(isMultiple?'flex-sm-row':'position-xs-relative start-0 end-0 top-0'):(isMultiple?'position-relative flex-sm-row':'position-relative')]">
            <!-- 多台列表 -->
            <div v-if="isMultiple" class="col-sm-7 col-lg-7 order-2 order-sm-1 flex-grow-1 flex-sm-grow-1 h-0 h-sm-100 pe-sm-2 py-2 py-sm-0">
                <room-list class="col-12 col-xl-6" :class="{'col-md-6':isMultiple}" :room-list="roomList" :count-list="countList" :pearl-obj="pearlObj" @on-ready="isModuleReady=true"></room-list>
            </div>
            <!-- 经典 -->
            <div :class="{'col-sm-5 col-md-4 col-xxl-3 order-1 h-sm-100':isMultiple,'flex-grow-0 flex-sm-grow-1 h-sm-0':gameModel==GAME_MODEL.normal}" class="d-flex flex-column flex-sm-row position-relative">
                <!-- 纵向导航 -->
                <navbar-vertical v-if="!isMultiple" class="d-none d-sm-flex" :is-fullscreen="isFullscreen"></navbar-vertical>
                <!-- 电话模式视频 -->
                <div class="d-flex flex-column flex-grow-1 flex-sm-row position-relative" v-if="gameModel==GAME_MODEL.tel">
                    <div class="col">
                        <div class="pt-60 h-0 position-relative">
                            <media-video class="border-start border-end border-secondary position-absolute top-0 start-0" :video-index="0" id="firstvideo" :video-list="videoList" :countdown="roomInfo.countdown" :room-class="(roomInfo.isar==1&&gameModel==GAME_MODEL.normal&&!isMultiple)?['top-xs-0 top-sm-5rem mt-2 mt-sm-1 ms-2']:['top-xs-0 top-sm-0 m-2']" :time-class="(roomInfo.isar==1&&gameModel==GAME_MODEL.normal&&!isMultiple)?['top-xs-0','top-sm-5rem top-xl-6rem','ms-2']:['top-0','m-2']" :img-class="(!isMultiple)?['h-100','w-100']:['position-absolute translate-middle top-50 start-50']"></media-video>
                        </div>
                    </div>
                    <div class="col">
                        <div class="pt-60 h-0 position-relative">
                            <media-video class="border-start border-end border-secondary position-absolute top-0 start-0" :video-index="1" id="secondvideo" :video-list="videoList" :room-class="['d-none']" :time-class="['d-none']" :img-class="(!isMultiple)?['h-100','w-100']:['position-absolute translate-middle top-50 start-50']"></media-video>
                        </div>
                    </div>
                </div>
                <!-- 视频区 -->
                <div v-else class="d-flex flex-column flex-grow-1 position-relative">
                    <!-- 公告 -->
                    <notice class="d-none d-sm-flex position-absolute index-12"></notice>
                    <!-- 视频 -->
                    <div class="d-flex h-0 pt-60 position-relative overflow-hidden" :class="{'flex-grow-1 pt-sm-0':!isMultiple}">
                        <!-- 印记 -->
                        <div class="position-absolute top-0 end-0 bottom-0 start-0 mt-2 mt-sm-3">
                            <task class="top end task-3_5rem mt-sm-4" :is-show-task="isShowTask"></task>
                        </div>
                        <media-video id="video1" class="position-xs-absolute top-0 start-0" :class="{'position-absolute':isMultiple,'position-sm-relative top-0 start-0':!isMultiple,'scale-video':isScale,'bg-transparent img-sm-thumbnail':roomInfo.isar!=1&&!isMultiple}" :video-index="0" :video-list="videoList" :countdown="roomInfo.countdown" :room-class="(!isMultiple)?['top-sm-0 mt-2 mt-sm-5 ms-1 ms-sm-2 index-12']:['top-sm-0']" :time-class="(!isMultiple)?['top-0 mt-2 mt-sm-5 ms-2']:['top-0 m-2 mt-sm-5']" :img-class="['position-absolute translate-middle top-50 start-50 w-100 h-sm-100']" @video-ready="videoReady"></media-video>
                        <media-video v-if="roomInfo.isar!=1&&!isMultiple" class="d-none d-sm-block" id="video2" :video-index="1" :class="{'scale-video':isScale,'bg-transparent img-sm-thumbnail':roomInfo.isar!=1}" :video-list="videoList" :countdown="roomInfo.countdown" :room-class="(!isMultiple)?['d-none']:['m-2']" :time-class="(!isMultiple)?['d-none']:['top-0 m-2']" :img-class="['position-absolute translate-middle top-50 start-50 w-100 h-sm-100 bg-transparent']" @video-ready="v=>readyVideoIdArr.push(v)"></media-video>
                        <!-- 下单信息区 -->
                        <div v-if="roomInfo.isar==1&&!isMultiple" class="d-none d-sm-block position-absolute bg-dark bg-opacity-50 end-0 bottom-0 rounded px-1 mb-5 me-1 fs-_8rem text-light">
                            <div class="d-flex line-bottom position-relative py-1">
                                <span class="text-light me-1">{{$t("room.ingBet")}}</span>
                                <div class="flex-grow-1 d-flex align-items-center w-4rem">
                                    <div class="rounded-pill flex-grow-1 fs-_6rem lh-sm d-flex justify-content-center align-items-center position-relative overflow-hidden" style="box-shadow: 0 0 .2rem #fff inset;">
                                        <span>{{getAmountCount("submiting",currRebate)}}</span>
                                        <div class="position-absolute top-0 start-0 h-100 bg-warning bg-gradient bg-opacity-75" :style="{'width':getAmountCountPercent(getAmountCount('submiting',currRebate))}" style="box-shadow: 0 0 .2rem #fff inset;"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex line-bottom position-relative py-1">
                                <span class="text-light me-1 d-flex align-items-center">{{$t("room.edBet")}}</span>
                                <div class="flex-grow-1 d-flex flex-column justify-content-center w-4rem">
                                    <div class="rounded-pill fs-_6rem lh-sm d-flex justify-content-center align-items-center position-relative overflow-hidden" style="box-shadow: 0 0 .2rem #fff inset;">
                                        <span v-if="roomInfo.iscommission==IS_REBATE.true" class="position-absolute start-0 top-0 ms-1">佣</span>
                                        <span>{{getAmountCount("submited",REBATE_TYPE.rebate)}}</span>
                                        <div class="position-absolute top-0 start-0 h-100 bg-warning bg-gradient bg-opacity-75" :style="{'width':getAmountCountPercent(getAmountCount('submited',REBATE_TYPE.rebate))}" style="box-shadow: 0 0 .2rem #fff inset;"></div>
                                    </div>
                                    <div v-if="roomInfo.iscommission==IS_REBATE.true" class="rounded-pill fs-_6rem lh-sm d-flex justify-content-center align-items-center position-relative overflow-hidden mt-1" style="box-shadow: 0 0 .2rem #fff inset;">
                                        <span class="position-absolute start-0 top-0 ms-1">免</span>
                                        <span>{{getAmountCount("submited",REBATE_TYPE.noRebate)}}</span>
                                        <div class="position-absolute top-0 start-0 h-100 bg-warning bg-gradient bg-opacity-75" :style="{'width':getAmountCountPercent(getAmountCount('submited',REBATE_TYPE.noRebate))}" style="box-shadow: 0 0 .2rem #fff inset;"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex py-1">
                                <span class="text-light me-1">{{$t("room.allBet")}}</span>
                                <div class="flex-grow-1 d-flex align-items-center w-4rem">
                                    <div class="rounded-pill flex-grow-1 fs-_6rem lh-sm d-flex justify-content-center align-items-center position-relative overflow-hidden" style="box-shadow: 0 0 .2rem #fff inset;">
                                        <span>{{getAmountCount("submited",REBATE_TYPE.rebate)+getAmountCount("submited",REBATE_TYPE.noRebate)+getAmountCount("submiting")}}</span>
                                        <div class="position-absolute top-0 start-0 h-100 bg-warning bg-gradient bg-opacity-75" :class="{'w-100':(getAmountCount('submited',REBATE_TYPE.rebate)+getAmountCount('submited',REBATE_TYPE.noRebate)+getAmountCount('submiting'))>0}" style="box-shadow: 0 0 .2rem #fff inset;"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 提交区 -->
                    <div class="position-xs-relative start-0 end-0 bottom-0 top-0" :class="{'position-sm-absolute':roomInfo.isar==1&&!isMultiple,'flex-grow-1 d-flex':isMultiple}">
                        <!-- 背景色(因内联样式无法使用媒体查询所以这么写) -->
                        <div class="position-absolute w-100 h-100 d-sm-none" :style="{'background':roomInfo.bgcolor}"></div>
                        <!-- 操作区 -->
                        <div v-if="gameModel==GAME_MODEL.normal" class="position-xs-relative bottom-0 index-12" :class="{'perspective-600':!isMultiple,'flex-grow-1 d-flex':isMultiple,'scale-submit':isScale==true,'translate-middle-x start-50 position-sm-absolute':roomInfo.isar==1&&!isMultiple,'position-sm-relative':roomInfo.isar!=1}">
                            <div class="pb-1 pt-sm-1 pb-sm-0 transform-3d" :class="{'flex-grow-1 d-flex mb-sm-1 mb-md-2':isMultiple,'mb-sm-2':!isMultiple,'rotate3d-x-sm-50':roomInfo.isar==1&&!isMultiple,'me-sm-2':roomInfo.isar!=1&&!isMultiple}">
                                <div class="d-flex flex-column transform-3d" :class="{'flex-grow-1':isMultiple,'flex-sm-row':!isMultiple}">
                                    <div class="d-flex flex-column flex-grow-1 transform-3d">
                                        <!-- 切换区1 -->
                                        <div class="d-flex justify-content-between mt-1 mb-1" :class="{'mt-sm-0 d-sm-none':!isMultiple}">
                                            <!-- 额度统计 -->
                                            <div class="d-flex text-light flex-grow-1 justify-content-around lh-1">
                                                <div class="flex-grow-1 d-flex justify-content-around" :class="{'fs-sm-5 justify-content-sm-start align-items-center':roomInfo.isar==1&&!isMultiple}">
                                                    <span class="d-flex align-items-center">{{$t("room.ingBet")}}：{{getAmountCount("submiting",currRebate)}}</span>
                                                    <span class="d-flex align-items-center" :class="{'ms-sm-2 ms-md-3 ms-lg-4':roomInfo.isar==1&&!isMultiple}">
                                                        <span>{{$t("room.edBet")}}：</span>
                                                        <span class="d-flex align-items-center me-2 me-sm-1">
                                                            <span>{{getAmountCount("submited",REBATE_TYPE.rebate)}}</span>
                                                            <span v-if="roomInfo.iscommission==IS_REBATE.true" :class="{'w-sm-1_5rem h-sm-1_5rem':roomInfo.isar==1&&!isMultiple}" class="rounded-circle badge bg-danger rounded-circle w-1rem h-1rem d-flex justify-content-center align-items-center border border-warning ms-1">佣</span>
                                                        </span>
                                                        <span v-if="roomInfo.iscommission==IS_REBATE.true" class="d-flex align-items-center">
                                                            <span>{{getAmountCount("submited",REBATE_TYPE.noRebate)}}</span>
                                                            <span :class="{'w-sm-1_5rem h-sm-1_5rem':roomInfo.isar==1&&!isMultiple}" class="rounded-circle badge bg-success rounded-circle w-1rem h-1rem d-flex justify-content-center align-items-center border border-warning ms-1">免</span>
                                                        </span>
                                                    </span>
                                                    <span class="d-flex align-items-center" :class="{'ms-sm-2 ms-md-3 ms-lg-4':roomInfo.isar==1&&!isMultiple}">{{$t("room.allBet")}}：{{getAmountCount("submited",REBATE_TYPE.rebate)+getAmountCount("submited",REBATE_TYPE.noRebate)+getAmountCount("submiting")}}</span>
                                                </div>
                                                <i @click="isShowPokerLayer=true" class="d-flex d-sm-none bi bi-suit-spade me-2"></i>
                                            </div>
                                        </div>
        
                                        <div class="d-flex flex-grow-1 flex-column-reverse transform-3d" :class="{'flex-sm-row':roomInfo.isar==1&&!isMultiple,'flex-row':roomInfo.isar!=1,'flex-sm-row-reverse':roomInfo.isar!=1&&!isMultiple}">
                                            <div :class="{'flex-sm-row ps-sm-1 pe-sm-2':roomInfo.isar!=1&&!isMultiple,'flex-sm-column-reverse':roomInfo.isar==1&&isMultiple}" class="d-flex flex-column px-1 px-sm-0">
                                                <!-- 选筹区 -->
                                                <div class="d-flex justify-content-between justify-content-sm-around text-black order-2 order-sm-1 mb-2 mb-sm-0 flex-grow-1" :class="{'py-sm-1 py-md-2 py-lg-3':isMultiple,'flex-sm-column':!isMultiple,'col':roomInfo.isar!=1}">
                                                    
                                                    <div v-for="(item,i) in currAmountList" :key="i" class="d-flex justify-content-around align-items-center col" :class="{'col-sm-auto justify-content-sm-start':roomInfo.isar==1&&!isMultiple}">
                                                        <div v-for="j in 2" :key="j" class="position-relative me-1 chips rounded-circle" :class="{active:amount==item[j-1]}" @click="amount=item[j-1]" role="button">
                                                            <button v-if="i==2&&j==2" @click.stop="isShowMoreAmount=!isShowMoreAmount" class="btn btn-secondary btn-shadow-left text-light">
                                                                <i class="bi bi-grid-fill"></i>
                                                            </button>
                                                            <chip v-else :foot-class="['bg-'+item[j-1],(roomInfo.isar==1&&!isMultiple)?'ms-sm-_1rem':'']" :face-class="['bg-'+item[j-1]]" :chip-text="$root.chipsTxtConvert(item[j-1])"></chip>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                            <!-- 下单区 -->
                                            <div :class="{'flex-column':roomInfo.isar!=1&&!isMultiple}" class="flex-grow-1 d-flex align-items-sm-stretch position-relative order-1 order-sm-2 text-center mb-2 mb-sm-0 transform-3d">
                                                <!-- 切换区2 -->
                                                <div v-if="roomInfo.isar!=1&&!isMultiple" class="d-none d-sm-flex justify-content-between mt-1 mb-1 small" :class="{'mt-sm-0':!isMultiple}">
                                                    <!-- 额度统计 -->
                                                    <div class="d-flex text-light flex-grow-1 lh-1 ms-2">
                                                        <div class="flex-grow-1 d-flex" :class="{'fs-sm-5 justify-content-sm-start align-items-center':roomInfo.isar==1&&!isMultiple}">
                                                            <span class="d-flex align-items-center">{{$t("room.ingBet")}}：{{getAmountCount("submiting",currRebate)}}</span>
                                                            <span class="d-flex align-items-center" :class="{'ms-sm-2 ms-md-3 ms-lg-4':!isMultiple}">
                                                                <span>{{$t("room.edBet")}}：</span>
                                                                <span class="d-flex align-items-center me-2 me-sm-1">
                                                                    <span>{{getAmountCount("submited",REBATE_TYPE.rebate)}}</span>
                                                                    <span v-if="roomInfo.iscommission==IS_REBATE.true" :class="{'w-sm-1_5rem h-sm-1_5rem':roomInfo.isar==1&&!isMultiple}" class="rounded-circle badge bg-danger rounded-circle w-1rem h-1rem d-flex justify-content-center align-items-center border border-warning ms-1">佣</span>
                                                                </span>
                                                                <span v-if="roomInfo.iscommission==IS_REBATE.true" class="d-flex align-items-center">
                                                                    <span>{{getAmountCount("submited",REBATE_TYPE.noRebate)}}</span>
                                                                    <span :class="{'w-sm-1_5rem h-sm-1_5rem':roomInfo.isar==1&&!isMultiple}" class="rounded-circle badge bg-success rounded-circle w-1rem h-1rem d-flex justify-content-center align-items-center border border-warning ms-1">免</span>
                                                                </span>
                                                            </span>
                                                            <span class="d-flex align-items-center" :class="{'ms-sm-2 ms-md-3 ms-lg-4':!isMultiple}">{{$t("room.allBet")}}：{{getAmountCount("submited",REBATE_TYPE.rebate)+getAmountCount("submited",REBATE_TYPE.noRebate)+getAmountCount("submiting")}}</span>
                                                        </div>
                                                        <i @click="isShowPokerLayer=true" class="d-flex d-sm-none bi bi-suit-spade me-2"></i>
                                                    </div>
                                                    <!-- 免佣 -->
                                                    <div class="d-none d-sm-flex">
                                                        <div class="form-switch d-flex align-items-center mb-0 me-sm-1 me-md-2">
                                                            <label class="me-1 text-light" for="cboRebateNew">{{$t("room.unRebate")}}</label>
                                                            <input class="form-check-input fs-5 m-0" type="checkbox" id="cboRebateNew" @change="setRebate($event)" :checked="currRebate==REBATE_TYPE.noRebate">
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- 旧改下单位 -->
                                                <div :class="{'flex-grow-1':!isMultiple,'flex-grow-1 align-items-sm-stretch':isMultiple,'flex-sm-nowrap':!isMultiple}" class="d-flex flex-wrap align-items-sm-end align-items-sm-stretch position-relative order-1 order-sm-2 text-center transform-3d pe-1 pe-sm-0">
                                                    <!-- xd -->
                                                    <div v-if="roomInfo.game==GAME_ID.bac" class="d-flex col-4 transform-3d flex-grow-1" :class="{'col-sm-auto order-sm-1':!isMultiple}">
                                                        <div class="d-flex flex-column align-items-center justify-content-between border-solid border-xs rounded-5 border-light position-relative flex-grow-1 transform-3d mb-2 ms-1 layer-absolute-radius" :class="{'border-sm-2 border-md-3 border-lg-4 layer-absolute-sm-radius mb-sm-0':!isMultiple,'coruscate':coruscateArr.indexOf('xd')!=-1,'layer-absolute':odds.xd==0}" @click="addAmount('xd',$event)">
                                                            <!-- 鼠标上移遮罩层，用这个方法是了避免hover时，因3d变换导致hover在谷歌浏览器失效 -->
                                                            <div class="position-absolute w-100 h-100 start-0 top-0 index-1">
                                                                <div class="w-100 h-100 hover-light"></div>
                                                            </div>
                                                            <!-- 文字 -->
                                                            <span class="fw-bold flex-grow-1 d-flex justify-content-center flex-column text-nowrap text-shadow-white fs-2" :class="[isMultiple?'my-sm-0 my-lg-1 lh-sm-1':'',(roomInfo.pokermode==POKER_TYPE.show?'w-8rem':'w-6rem')]" :style="{'color':COLOR.blueDark}">{{$t("common.xd")}}</span>
                                                            <!-- 信息 -->
                                                            <div class="text-nowrap" :class="[isMultiple?'lh-sm-1 lh-xl-2':'']">
                                                                <div class="fw-bold text-light">1:{{odds.xd}}</div>
                                                                <div class="small text-light text-opacity-50">{{limitred.xd}}</div>
                                                            </div>
                                                            <!-- 单额 -->
                                                            <div class="position-absolute start-50 me-5 me-sm-4 top-55 w-0 h-0 transform-3d">
                                                                <div :class="{'chip-pulse opacity-75':submiting.xd>0}" class="position-absolute">
                                                                    <div v-for="j,index in chipsConvert(submited[currRebate].xd+submiting.xd)" :key="j" :style="'bottom:'+(0.2*index)+'rem !important'" class="position-absolute translate-middle-x fs-6 text-black" :class="{'chips-img-shadow':index==0}">
                                                                        <chip :foot-class="['bg-'+j]" :face-class="['bg-'+j]" :chip-text="$root.chipsTxtConvert(j)"></chip>
                                                                        <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                                    </div>
                                                                </div>
                                                                <!-- 气泡 -->
                                                                <div v-if="submited[currRebate].xd+submiting.xd>0" :class="[roomInfo.isar==1&&!isMultiple?'anim-updown-3d':'anim-updown']" class="position-absolute text-black fw-bold fs-6 bottom-0 p-2 rounded-circle bubble" style="transform:translateX(-50%) translateZ(3rem) rotateX(-50deg) translateZ(-2.5rem);">
                                                                    <span class="d-block scale pt-100 h-0">
                                                                        <span class="visibility-hidden" :class="{'fs-scale-1_2rem':isScaleAmount.xd}">{{submited[currRebate].xd+submiting.xd>0?submited[currRebate].xd+submiting.xd:''}}</span>
                                                                        <small :class="{'text-danger':submited[currRebate].xd+submiting.xd<limitred.xd.split('-')[0]}" class="text-shadow-white position-absolute top-50 start-50 translate-middle">{{submited[currRebate].xd+submiting.xd>0?submited[currRebate].xd+submiting.xd:''}}</small>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- 池额 -->
                                                            <div @click.stop :class="{'rotate-sm-x-_50-z-4px':pool.xd>0&&roomInfo.isar==1&&!isMultiple}" class="position-absolute bottom-0 end-0 transform-bottom">
                                                                <div @mousemove="isShowPoolText=true" @mouseout="isShowPoolText=false" class="progress-ring fs-_8rem d-flex justify-content-center align-items-center position-relative rounded-pill overflow-hidden" :style="{background: 'conic-gradient(#00e5ff calc('+((pool.xd/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100||0).toFixed()+'%')+'), #787878 0)'}">
                                                                    <div :class="{'progress-text-show':isShowPoolText}" class="progress-text text-light h-1_5rem d-flex justify-content-center align-items-center m-_15rem">
                                                                        <span>{{(pool.xd/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100||0).toFixed()}}<span class="fs-_5rem">%</span></span>
                                                                        <span class="px-2">{{ pool.xd }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- h -->
                                                    <div class="d-flex col-4 transform-3d flex-grow-1" :class="{'col-sm-auto':!isMultiple,'order-sm-3':roomInfo.game==GAME_ID.bac&&!isMultiple,'order-2':roomInfo.game!=GAME_ID.bac}">
                                                        <div class="d-flex flex-column align-items-center justify-content-between border-solid border-xs rounded-5 border-light position-relative flex-grow-1 transform-3d ms-1 layer-absolute-radius" :class="{'border-sm-2 border-md-3 border-lg-4 layer-absolute-sm-radius mb-sm-0':!isMultiple,'coruscate':coruscateArr.indexOf('h')!=-1,'layer-absolute':odds.h==0,'mb-2':roomInfo.game==GAME_ID.bac}" @click="addAmount('h',$event)">
                                                            <!-- 鼠标上移遮罩层，用这个方法是了避免hover时，因3d变换导致hover在谷歌浏览器失效 -->
                                                            <div class="position-absolute w-100 h-100 start-0 top-0 index-1">
                                                                <div class="w-100 h-100 hover-light"></div>
                                                            </div>
                                                            <!-- 文字 -->
                                                            <span class="fw-bold flex-grow-1 d-flex justify-content-center flex-column text-shadow-white" :class="[roomInfo.game==GAME_ID.lh?'fs-xs-2 fs-sm-2 lh-2-4 my-2 my-sm-0 lh-4 lh-sm-base border-sm-0':'',isMultiple?(roomInfo.game==GAME_ID.lh?'fs-xs-2 h1-sm lh-2-4 my-2 my-sm-0 my-lg-2':'fs-2 my-sm-0 my-lg-1 lh-sm-1'):(roomInfo.game==GAME_ID.lh?'mx-sm-5 mx-md-4 px-sm-3 px-md-5':'fs-2 '+(roomInfo.pokermode==POKER_TYPE.show?'w-8rem':'w-6rem'))]" :style="'color:'+COLOR.green">{{$t("common.h")}}</span>
                                                            <!-- 信息 -->
                                                            <div class="text-nowrap">
                                                                <div class="fw-bold text-light" :class="[roomInfo.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(roomInfo.game==GAME_ID.lh?'lh-xs-3 lh-sm-2 lh-xl-4':'lh-sm-1 lh-xl-2'):(roomInfo.game==GAME_ID.lh?'':'')]">1:{{odds.h}}</div>
                                                                <div class="small text-light text-opacity-50" :class="[roomInfo.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(roomInfo.game==GAME_ID.lh?'lh-xs-3 lh-sm-2 lh-xl-4':'lh-sm-1 lh-xl-2'):(roomInfo.game==GAME_ID.lh?'':'')]">{{limitred.h}}</div>
                                                            </div>
                                                            <!-- 单额 -->
                                                            <div class="position-absolute start-50 me-5 me-sm-4 top-55 w-0 h-0 transform-3d">
                                                                <div :class="{'chip-pulse opacity-75':submiting.h>0}" class="position-absolute">
                                                                    <div v-for="j,index in chipsConvert(submited[currRebate].h+submiting.h)" :key="j" :style="'bottom:'+(0.2*index)+'rem !important'" class="position-absolute fs-6 text-black translate-middle-x" :class="{'chips-img-shadow':index==0}">
                                                                        <chip :foot-class="['bg-'+j]" :face-class="['bg-'+j]" :chip-text="$root.chipsTxtConvert(j)"></chip>
                                                                        <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                                    </div>
                                                                </div>
                                                                <div v-if="submited[currRebate].h+submiting.h>0" :class="[roomInfo.isar==1&&!isMultiple?'anim-updown-3d':'anim-updown']" class="position-absolute text-black fw-bold fs-6 bottom-0 p-2 rounded-circle bubble" style="transform:translateX(-50%) translateZ(3rem) rotateX(-50deg) translateZ(-2.5rem);">
                                                                    <span class="d-block scale pt-100 h-0">
                                                                        <span class="visibility-hidden" :class="{'fs-scale-1_2rem':isScaleAmount.h}">{{submited[currRebate].h+submiting.h>0?submited[currRebate].h+submiting.h:''}}</span>
                                                                        <small :class="{'text-danger':submited[currRebate].h+submiting.h<limitred.h.split('-')[0]}" class="text-shadow-white position-absolute top-50 start-50 translate-middle">{{submited[currRebate].h+submiting.h>0?submited[currRebate].h+submiting.h:''}}</small>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- 池额 -->
                                                            <div @click.stop :class="{'rotate-sm-x-_50-z-4px':pool.h>0&&roomInfo.isar==1&&!isMultiple}" class="position-absolute bottom-0 end-0 transform-bottom">
                                                                <div @mousemove="isShowPoolText=true" @mouseout="isShowPoolText=false" class="progress-ring fs-_8rem d-flex justify-content-center align-items-center position-relative rounded-pill overflow-hidden" :style="{background: 'conic-gradient(#00e5ff calc('+((pool.h/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100||0).toFixed()+'%')+'), #787878 0)'}">
                                                                    <div :class="{'progress-text-show':isShowPoolText}" class="progress-text text-light h-1_5rem d-flex justify-content-center align-items-center m-_15rem">
                                                                        <span>{{(pool.h/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100||0).toFixed()}}<span class="fs-_5rem">%</span></span>
                                                                        <span class="px-2">{{ pool.h }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- zd -->
                                                    <div v-if="roomInfo.game==GAME_ID.bac" class="d-flex col-4 flex-column transform-3d flex-grow-1" :class="{'col-sm-auto order-sm-5':!isMultiple}">
                                                        <div class="d-flex flex-column align-items-center justify-content-between border-solid border-xs rounded-5 border-light position-relative flex-grow-1 transform-3d mb-2 ms-1 layer-absolute-radius" :class="{'border-sm-2 border-md-3 border-lg-4 layer-absolute-sm-radius mb-sm-0':!isMultiple,'coruscate':coruscateArr.indexOf('zd')!=-1,'layer-absolute':odds.zd==0}" @click="addAmount('zd',$event)">
                                                            <!-- 鼠标上移遮罩层，用这个方法是了避免hover时，因3d变换导致hover在谷歌浏览器失效 -->
                                                            <div class="position-absolute w-100 h-100 start-0 top-0 index-1">
                                                                <div class="w-100 h-100 hover-light"></div>
                                                            </div>
                                                            <!-- 文字 -->
                                                            <span class="fw-bold flex-grow-1 d-flex justify-content-center flex-column text-nowrap text-shadow-white fs-2" :class="[isMultiple?'my-sm-0 my-lg-1 lh-sm-1':'',(roomInfo.pokermode==POKER_TYPE.show?'w-8rem':'w-6rem')]" :style="'color:'+COLOR.redDark">{{$t("common.zd")}}</span>
                                                            <!-- 信息 -->
                                                            <div class="text-nowrap" :class="[isMultiple?'lh-sm-1 lh-xl-2':'']">
                                                                <div class="fw-bold text-light">1:{{odds.zd}}</div>
                                                                <div class="small text-light text-opacity-50">{{limitred.zd}}</div>
                                                            </div>
                                                            <!-- 单额 -->
                                                            <div class="position-absolute start-50 me-5 me-sm-4 top-55 w-0 h-0 transform-3d">
                                                                <div :class="{'chip-pulse opacity-75':submiting.zd>0}" class="position-absolute">
                                                                    <div v-for="j,index in chipsConvert(submited[currRebate].zd+submiting.zd)" :key="j" :style="'bottom:'+(0.2*index)+'rem !important'" class="position-absolute translate-middle-x fs-6 text-black" :class="{'chips-img-shadow':index==0}">
                                                                        <chip :foot-class="['bg-'+j]" :face-class="['bg-'+j]" :chip-text="$root.chipsTxtConvert(j)"></chip>
                                                                        <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                                    </div>
                                                                </div>
                                                                <div v-if="submited[currRebate].zd+submiting.zd>0" :class="[roomInfo.isar==1&&!isMultiple?'anim-updown-3d':'anim-updown']" class="position-absolute text-black fw-bold fs-6 bottom-0 p-2 rounded-circle bubble" style="transform:translateX(-50%) translateZ(3rem) rotateX(-50deg) translateZ(-2.5rem);">
                                                                    <span class="d-block scale pt-100 h-0">
                                                                        <span class="visibility-hidden" :class="{'fs-scale-1_2rem':isScaleAmount.zd}">{{submited[currRebate].zd+submiting.zd>0?submited[currRebate].zd+submiting.zd:''}}</span>
                                                                        <small :class="{'text-danger':submited[currRebate].zd+submiting.zd<limitred.zd.split('-')[0]}" class="text-shadow-white position-absolute top-50 start-50 translate-middle">{{submited[currRebate].zd+submiting.zd>0?submited[currRebate].zd+submiting.zd:''}}</small>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <!-- 池额 -->
                                                            <div @click.stop :class="{'rotate-sm-x-_50-z-4px':pool.zd>0&&roomInfo.isar==1&&!isMultiple}" class="position-absolute bottom-0 end-0 transform-bottom">
                                                                <div @mousemove="isShowPoolText=true" @mouseout="isShowPoolText=false" class="progress-ring fs-_8rem d-flex justify-content-center align-items-center position-relative rounded-pill overflow-hidden" :style="{background: 'conic-gradient(#00e5ff calc('+((pool.zd/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100||0).toFixed()+'%')+'), #787878 0)'}">
                                                                    <div :class="{'progress-text-show':isShowPoolText}" class="progress-text text-light h-1_5rem d-flex justify-content-center align-items-center m-_15rem">
                                                                        <span>{{(pool.zd/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100||0).toFixed()}}<span class="fs-_5rem">%</span></span>
                                                                        <span class="px-2">{{ pool.zd }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- x -->
                                                    <div class="d-flex flex-column transform-3d" :class="{'flex-grow-1':!hasPointMode,'col-3':hasPointMode,'col-sm-auto':!isMultiple,'col-sm-4':hasPointMode&&isMultiple,'col-sm-6':roomInfo.game==GAME_ID.bac&&!hasPointMode&&isMultiple,'order-sm-2':roomInfo.game==GAME_ID.bac,'col-4 order-3':roomInfo.game!=GAME_ID.bac}">
                                                        <div class="d-flex border-solid border-xs rounded-5 border-light position-relative flex-grow-1 transform-3d ms-1" :class="{'coruscate':coruscateArr.indexOf('x')!=-1,'border-sm-2 border-md-3 border-lg-4':!isMultiple,'me-sm-2':roomInfo.game!=GAME_ID.bac&&!isMultiple}">
                                                            <!-- 基础玩法 -->
                                                            <div class="d-flex flex-column align-items-center justify-content-between rounded-5 position-relative flex-grow-1 transform-3d layer-absolute-radius" :class="{'layer-absolute':odds.x==0}" @click="addAmount('x',$event)">
                                                                <!-- 鼠标上移遮罩层，用这个方法是了避免hover时，因3d变换导致hover在谷歌浏览器失效 -->
                                                                <div class="position-absolute w-100 h-100 start-0 top-0 index-1">
                                                                    <div class="w-100 h-100 hover-light"></div>
                                                                </div>
                                                                <!-- 文字 -->
                                                                <span class="fw-bold flex-grow-1 d-flex justify-content-center flex-column text-shadow-white" :class="[roomInfo.game==GAME_ID.lh?'fs-xs-2 fs-sm-2 lh-2-4 my-2 my-sm-0 fs-2 lh-4 lh-sm-base border-sm-0':'',isMultiple?(roomInfo.game==GAME_ID.lh?'fs-xs-2 h1-sm lh-2-4 my-2 my-sm-0 my-lg-2':'fs-2 my-sm-0 my-lg-1 lh-sm-1'):(roomInfo.game==GAME_ID.lh?'mx-sm-5 mx-md-4 px-sm-3 px-md-5':'fs-2 '+(roomInfo.pokermode==POKER_TYPE.show?'w-8rem':'w-6rem'))]" :style="'color:'+COLOR.blue">{{$root.getTextByGame("common.",roomInfo.game,1)}}</span>
                                                                <!-- 信息 -->
                                                                <div class="text-nowrap">
                                                                    <div class="fw-bold text-light" :class="[roomInfo.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(roomInfo.game==GAME_ID.lh?'lh-xs-3 lh-sm-2 lh-xl-4':'lh-sm-1 lh-xl-2'):(roomInfo.game==GAME_ID.lh?'':'')]">1:{{currRebate==REBATE_TYPE.rebate?odds.x:1}}</div>
                                                                    <div class="small text-light text-opacity-50" :class="[roomInfo.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(roomInfo.game==GAME_ID.lh?'lh-xs-3 lh-sm-2 lh-xl-4':'lh-sm-1 lh-xl-2'):(roomInfo.game==GAME_ID.lh?'':'')]">{{limitred.x}}</div>
                                                                </div>
                                                                <!-- 单额 -->
                                                                <div class="position-absolute start-50 me-5 me-sm-4 top-55 w-0 h-0 transform-3d">
                                                                    <div :class="{'chip-pulse opacity-75':submiting.x>0}" class="position-absolute">
                                                                        <div v-for="j,index in chipsConvert(submited[currRebate].x+submiting.x)" :key="j" :style="'bottom:'+(0.2*index)+'rem !important'" class="position-absolute fs-6 text-black translate-middle-x" :class="{'chips-img-shadow':index==0}">
                                                                            <chip :foot-class="['bg-'+j]" :face-class="['bg-'+j]" :chip-text="$root.chipsTxtConvert(j)"></chip>
                                                                            <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div v-if="submited[currRebate].x+submiting.x>0" :class="[roomInfo.isar==1&&!isMultiple?'anim-updown-3d':'anim-updown']" class="position-absolute text-black fw-bold fs-6 bottom-0 p-2 rounded-circle bubble" style="transform:translateX(-50%) translateZ(3rem) rotateX(-50deg) translateZ(-2.5rem);">
                                                                        <span class="d-block scale pt-100 h-0">
                                                                            <span class="visibility-hidden" :class="{'fs-scale-1_2rem':isScaleAmount.x}">{{submited[currRebate].x+submiting.x>0?submited[currRebate].x+submiting.x:''}}</span>
                                                                            <small :class="{'text-danger':submited[currRebate].x+submiting.x<limitred.x.split('-')[0]}" class="text-shadow-white position-absolute top-50 start-50 translate-middle">{{submited[currRebate].x+submiting.x>0?submited[currRebate].x+submiting.x:''}}</small>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <!-- 池额 -->
                                                                <div @click.stop :class="{'rotate-sm-x-_50-z-4px':pool.x>0&&roomInfo.isar==1&&!isMultiple}" class="position-absolute bottom-0 end-0 transform-bottom">
                                                                    <div @mousemove="isShowPoolText=true" @mouseout="isShowPoolText=false" class="progress-ring fs-_8rem d-flex justify-content-center align-items-center position-relative rounded-pill overflow-hidden" :style="{background: 'conic-gradient(#00e5ff calc('+((pool.x/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100||0).toFixed()+'%')+'), #787878 0)'}">
                                                                        <div :class="{'progress-text-show':isShowPoolText}" class="progress-text text-light h-1_5rem d-flex justify-content-center align-items-center m-_15rem">
                                                                            <span>{{(pool.x/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100||0).toFixed()}}<span class="fs-_5rem">%</span></span>
                                                                            <span class="px-2">{{ pool.x }}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- 点数玩法 -->
                                                    <div v-if="hasPointMode" :class="{'order-sm-last col-sm-auto':!isMultiple,'order-sm-3 col-sm-4':isMultiple}" class="d-flex flex-column transform-3d flex-grow-1 col-6">
                                                        <div class="d-flex border-solid border-xs rounded-5 border-light position-relative flex-grow-1 transform-3d ms-1" :class="{'border-sm-2 border-md-3 border-lg-4':!isMultiple,'ms-sm-2':roomInfo.game!=GAME_ID.bac&&!isMultiple}">
                                                            <!-- 扣7 -->
                                                            <div @click="addAmount('x7z6',$event)" :class="{'layer-absolute-start-radius layer-absolute-start-sm-radius px-sm-2 flex-grow-1 flex-sm-grow-0':!isMultiple,'flex-grow-1':isMultiple,'coruscate':coruscateArr.indexOf('x7z6')!=-1,'layer-absolute':odds.x7z6==0}" class="d-flex flex-column align-items-center justify-content-center border-light border border-2 border-start-0 border-top-0 border-bottom-0 text-nowrap fw-bold position-relative transform-3d rounded-start-3 rounded-end-0">
                                                                <!-- 鼠标上移遮罩层，用这个方法是了避免hover时，因3d变换导致hover在谷歌浏览器失效 -->
                                                                <div class="position-absolute w-100 h-100 start-0 top-0">
                                                                    <div class="w-100 h-100 hover-light"></div>
                                                                </div>
                                                                <!-- 文字 -->
                                                                <div class="d-flex flex-column text-light text-shadow-white">
                                                                    <div :style="'color:'+COLOR.blue">
                                                                        <span>闲</span>
                                                                        <span>7点</span>
                                                                    </div>
                                                                    <div :style="'color:'+COLOR.red">
                                                                        <span>庄</span>
                                                                        <span>6点</span>
                                                                    </div>
                                                                </div>
                                                                <!-- 信息 -->
                                                                <div class="d-flex flex-column fs-_6rem text-white-50">
                                                                    <span class="text-light">1:{{ odds.x7z6 }}</span>
                                                                    <span>{{limitred.x7z6}}</span>
                                                                </div>
                                                                <!-- 单额 -->
                                                                <div class="position-absolute start-50 me-5 me-sm-4 top-55 w-0 h-0 transform-3d">
                                                                    <div :class="{'chip-pulse opacity-75':submiting.x7z6>0}" class="position-absolute">
                                                                        <div v-for="j,index in chipsConvert(submited[currRebate].x7z6+submiting.x7z6)" :key="j" :style="'bottom:'+(0.2*index)+'rem !important'" class="position-absolute fs-6 text-black translate-middle-x" :class="{'chips-img-shadow':index==0}">
                                                                            <chip :foot-class="['bg-'+j]" :face-class="['bg-'+j]" :chip-text="$root.chipsTxtConvert(j)"></chip>
                                                                            <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div v-if="submited[currRebate].x7z6+submiting.x7z6>0" :class="[roomInfo.isar==1&&!isMultiple?'anim-updown-3d':'anim-updown']" class="position-absolute text-black fw-bold fs-6 bottom-0 p-2 rounded-circle bubble" style="transform:translateX(-50%) translateZ(3rem) rotateX(-50deg) translateZ(-2.5rem);">
                                                                        <span class="d-block scale pt-100 h-0">
                                                                            <span class="visibility-hidden" :class="{'fs-scale-1_2rem':isScaleAmount.x7z6}">{{submited[currRebate].x7z6+submiting.x7z6>0?submited[currRebate].x7z6+submiting.x7z6:''}}</span>
                                                                            <small :class="{'text-danger':submited[currRebate].x7z6+submiting.x7z6<limitred.x7z6.split('-')[0]}" class="text-shadow-white position-absolute top-50 start-50 translate-middle">{{submited[currRebate].x7z6+submiting.x7z6>0?submited[currRebate].x7z6+submiting.x7z6:''}}</small>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <!-- 扣6 -->
                                                            <div :class="{'flex-grow-1':isMultiple}" class="flex-grow-1 d-flex flex-sm-column align-items-sm-center border-light border-2 border-end-0 border-top-0 border-bottom-0 text-nowrap fw-bold transform-3d">
                                                                <!-- z36 -->
                                                                <div :class="{'coruscate':coruscateArr.indexOf('z36')!=-1,'layer-absolute':odds.z36==0}" class="col w-100 d-flex flex-column flex-sm-row align-items-center justify-content-evenly justify-content-sm-center border-dashed border-light border-2 border-start-xs-0 border-top-xs-0 border-bottom-xs-0 border-start-sm-0 border-top-sm-0 border-end-sm-0 position-relative transform-3d rounded-end-top-sm-3" @click="addAmount('z36',$event)">
                                                                    <!-- 鼠标上移遮罩层，用这个方法是了避免hover时，因3d变换导致hover在谷歌浏览器失效 -->
                                                                    <div class="position-absolute w-100 h-100 start-0 top-0">
                                                                        <div class="w-100 h-100 hover-light"></div>
                                                                    </div>
                                                                    <!-- 文字 -->
                                                                    <div class="d-flex flex-column fs-_7rem lh-sm-1 px-1 text-light">
                                                                        <span><span class="text-shadow-white" :style="'color:'+COLOR.red">庄</span>3张</span>
                                                                        <span>6点赢</span>
                                                                    </div>
                                                                    <!-- 信息 -->
                                                                    <div class="d-flex flex-column fs-_6rem px-1 text-white-50 lh-1">
                                                                        <span class="text-light">1:{{ odds.z36 }}</span>
                                                                        <span class="text-xs-normal">{{limitred.z36}}</span>
                                                                    </div>
                                                                    <!-- 单额 -->
                                                                    <div class="position-absolute start-50 me-5 me-sm-4 top-80 w-0 h-0 transform-3d">
                                                                        <div :class="{'chip-pulse opacity-75':submiting.z36>0}" class="position-absolute scale-_6">
                                                                            <div v-for="j,index in chipsConvert(submited[currRebate].z36+submiting.z36)" :key="j" :style="'bottom:'+(0.2*index)+'rem !important'" class="position-absolute fs-6 text-black translate-middle-x" :class="{'chips-img-shadow':index==0}">
                                                                                <chip :foot-class="['bg-'+j]" :face-class="['bg-'+j]" :chip-text="$root.chipsTxtConvert(j)"></chip>
                                                                                <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div v-if="submited[currRebate].z36+submiting.z36>0" @click.stop :class="[roomInfo.isar==1&&!isMultiple?'anim-updown-3d':'anim-updown']" class="position-absolute text-black fw-bold fs-6 bottom-0 p-2 rounded-circle bubble pointer-events" style="transform:translateX(-50%) translateZ(3rem) rotateX(-50deg) translateZ(-2.5rem);">
                                                                            <span class="d-block scale pt-100 h-0">
                                                                                <span class="visibility-hidden" :class="{'fs-scale-1_2rem':isScaleAmount.z36}">{{submited[currRebate].z36+submiting.z36>0?submited[currRebate].z36+submiting.z36:''}}</span>
                                                                                <small :class="{'text-danger':submited[currRebate].z36+submiting.z36<limitred.z36.split('-')[0]}" class="text-shadow-white position-absolute top-50 start-50 translate-middle">{{submited[currRebate].z36+submiting.z36>0?submited[currRebate].z36+submiting.z36:''}}</small>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <!-- z26 -->
                                                                <div :class="{'coruscate':coruscateArr.indexOf('z26')!=-1,'layer-absolute':odds.z26==0}" class="col w-100 d-flex flex-column flex-sm-row align-items-center justify-content-evenly justify-content-sm-center border-dashed border-light border-2 border-start-xs-0 border-top-xs-0 border-bottom-xs-0 border-start-sm-0 border-top-sm-0 border-end-sm-0 position-relative transform-3d" @click="addAmount('z26',$event)">
                                                                    <!-- 鼠标上移遮罩层，用这个方法是了避免hover时，因3d变换导致hover在谷歌浏览器失效 -->
                                                                    <div class="position-absolute w-100 h-100 start-0 top-0">
                                                                        <div class="w-100 h-100 hover-light"></div>
                                                                    </div>
                                                                    <!-- 文字 -->
                                                                    <div class="d-flex flex-column fs-_7rem lh-sm-1 px-1 text-light">
                                                                        <span><span class="text-shadow-white" :style="'color:'+COLOR.red">庄</span>2张</span>
                                                                        <span>6点赢</span>
                                                                    </div>
                                                                    <!-- 信息 -->
                                                                    <div class="d-flex flex-column fs-_6rem px-1 text-white-50 lh-1">
                                                                        <span class="text-light">1:{{ odds.z26 }}</span>
                                                                        <span class="text-xs-normal">{{limitred.z26}}</span>
                                                                    </div>
                                                                    <!-- 单额 -->
                                                                    <div class="position-absolute start-50 me-5 me-sm-4 top-80 w-0 h-0 transform-3d">
                                                                        <div :class="{'chip-pulse opacity-75':submiting.z26>0}" class="position-absolute scale-_6">
                                                                            <div v-for="j,index in chipsConvert(submited[currRebate].z26+submiting.z26)" :key="j" :style="'bottom:'+(0.2*index)+'rem !important'" class="position-absolute fs-6 text-black translate-middle-x" :class="{'chips-img-shadow':index==0}">
                                                                                <chip :foot-class="['bg-'+j]" :face-class="['bg-'+j]" :chip-text="$root.chipsTxtConvert(j)"></chip>
                                                                                <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div v-if="submited[currRebate].z26+submiting.z26>0" @click.stop :class="[roomInfo.isar==1&&!isMultiple?'anim-updown-3d':'anim-updown']" class="position-absolute text-black fw-bold fs-6 bottom-0 p-2 rounded-circle bubble pointer-events" style="transform:translateX(-50%) translateZ(3rem) rotateX(-50deg) translateZ(-2.5rem);">
                                                                            <span class="d-block scale pt-100 h-0">
                                                                                <span class="visibility-hidden" :class="{'fs-scale-1_2rem':isScaleAmount.z26}">{{submited[currRebate].z26+submiting.z26>0?submited[currRebate].z26+submiting.z26:''}}</span>
                                                                                <small :class="{'text-danger':submited[currRebate].z26+submiting.z26<limitred.z26.split('-')[0]}" class="text-shadow-white position-absolute top-50 start-50 translate-middle">{{submited[currRebate].z26+submiting.z26>0?submited[currRebate].z26+submiting.z26:''}}</small>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <!-- z6 -->
                                                                <div :class="{'coruscate':coruscateArr.indexOf('z6')!=-1,'layer-absolute':odds.z6==0}" class="col w-100 d-flex flex-column flex-sm-row align-items-center justify-content-evenly justify-content-sm-center position-relative transform-3d rounded-end-5 rounded-end-top-sm-0 rounded-end-bottom-sm-3" @click="addAmount('z6',$event)">
                                                                    <!-- 鼠标上移遮罩层，用这个方法是了避免hover时，因3d变换导致hover在谷歌浏览器失效 -->
                                                                    <div class="position-absolute w-100 h-100 start-0 top-0">
                                                                        <div class="w-100 h-100 hover-light"></div>
                                                                    </div>
                                                                    <!-- 文字 -->
                                                                    <div class="d-flex flex-column fs-_7rem lh-sm-1 px-1 text-light">
                                                                        <span><span class="text-shadow-white" :style="'color:'+COLOR.red">庄</span>赢</span>
                                                                        <span>6点</span>
                                                                    </div>
                                                                    <!-- 信息 -->
                                                                    <div class="d-flex flex-column fs-_6rem px-1 text-white-50 lh-1">
                                                                        <span class="text-light">1:{{ odds.z6 }}</span>
                                                                        <span class="text-xs-normal">{{limitred.z6}}</span>
                                                                    </div>
                                                                    <!-- 单额 -->
                                                                    <div class="position-absolute start-50 me-5 me-sm-4 top-80 w-0 h-0 transform-3d">
                                                                        <div :class="{'chip-pulse opacity-75':submiting.z6>0}" class="position-absolute scale-_6">
                                                                            <div v-for="j,index in chipsConvert(submited[currRebate].z6+submiting.z6)" :key="j" :style="'bottom:'+(0.2*index)+'rem !important'" class="position-absolute fs-6 text-black translate-middle-x" :class="{'chips-img-shadow':index==0}">
                                                                                <chip :foot-class="['bg-'+j]" :face-class="['bg-'+j]" :chip-text="$root.chipsTxtConvert(j)"></chip>
                                                                                <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div v-if="submited[currRebate].z6+submiting.z6>0" @click.stop :class="[roomInfo.isar==1&&!isMultiple?'anim-updown-3d':'anim-updown']" class="position-absolute text-black fw-bold fs-6 bottom-0 p-2 rounded-circle bubble pointer-events" style="transform:translateX(-50%) translateZ(3rem) rotateX(-50deg) translateZ(-2.5rem);">
                                                                            <span class="d-block scale pt-100 h-0">
                                                                                <span class="visibility-hidden" :class="{'fs-scale-1_2rem':isScaleAmount.z6}">{{submited[currRebate].z6+submiting.z6>0?submited[currRebate].z6+submiting.z6:''}}</span>
                                                                                <small :class="{'text-danger':submited[currRebate].z6+submiting.z6<limitred.z6.split('-')[0]}" class="text-shadow-white position-absolute top-50 start-50 translate-middle">{{submited[currRebate].z6+submiting.z6>0?submited[currRebate].z6+submiting.z6:''}}</small>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- z -->
                                                    <div class="d-flex flex-column transform-3d" :class="{'flex-grow-1':!hasPointMode,'col-3':hasPointMode,'col-sm-auto':!isMultiple,'col-sm-4':hasPointMode&&isMultiple,'col-sm-6':roomInfo.game==GAME_ID.bac&&!hasPointMode&&isMultiple,'order-sm-4':roomInfo.game==GAME_ID.bac,'col-4 order-1':roomInfo.game!=GAME_ID.bac}">
                                                        <div class="d-flex border-solid border-xs rounded-5 border-light position-relative flex-grow-1 transform-3d ms-1" :class="{'coruscate':coruscateArr.indexOf('z')!=-1,'border-sm-2 border-md-3 border-lg-4':!isMultiple,'ms-sm-2':roomInfo.game!=GAME_ID.bac&&!isMultiple}">
                                                            <!-- 基础玩法 -->
                                                            <div class="d-flex flex-column align-items-center justify-content-between rounded-5 position-relative flex-grow-1 transform-3d layer-absolute-radius" :class="{'layer-absolute':odds.z==0}" @click="addAmount('z',$event)">
                                                                <!-- 鼠标上移遮罩层，用这个方法是了避免hover时，因3d变换导致hover在谷歌浏览器失效 -->
                                                                <div class="position-absolute w-100 h-100 start-0 top-0 index-1">
                                                                    <div class="w-100 h-100 hover-light"></div>
                                                                </div>
                                                                <!-- 文字 -->
                                                                <span class="fw-bold flex-grow-1 d-flex justify-content-center flex-column text-shadow-white" :class="[roomInfo.game==GAME_ID.lh?'fs-xs-2 fs-sm-2 lh-2-4 mb-2 mt-3 my-sm-0 fs-2 lh-4 lh-sm-base border-sm-0':'',isMultiple?(roomInfo.game==GAME_ID.lh?'fs-xs-2 h1-sm lh-2-4 my-2 my-sm-0 my-lg-2':'fs-2 my-sm-0 my-lg-1 lh-sm-1'):(roomInfo.game==GAME_ID.lh?'mx-sm-5 mx-md-4 px-sm-3 px-md-5':'fs-2 '+(roomInfo.pokermode==POKER_TYPE.show?'w-8rem':'w-6rem'))]" :style="'color:'+COLOR.red">{{$root.getTextByGame("common.",roomInfo.game,0)}}</span>
                                                                <!-- 信息 -->
                                                                <div class="text-nowrap">
                                                                    <div class="fw-bold text-light" :class="[roomInfo.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(roomInfo.game==GAME_ID.lh?'lh-xs-3 lh-sm-2 lh-xl-4':'lh-sm-1 lh-xl-2'):(roomInfo.game==GAME_ID.lh?'':'')]">1:{{currRebate==REBATE_TYPE.rebate?odds.z:1+(roomInfo.game==GAME_ID.bac?'('+$t("room.rebateTxt")+')':'')}}</div>
                                                                    <div class="small text-light text-opacity-50" :class="[roomInfo.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(roomInfo.game==GAME_ID.lh?'lh-xs-3 lh-sm-2 lh-xl-4':'lh-sm-1 lh-xl-2'):(roomInfo.game==GAME_ID.lh?'':'')]">{{limitred.z}}</div>
                                                                </div>
                                                                <!-- 单额 -->
                                                                <div class="position-absolute start-50 me-5 me-sm-4 top-55 w-0 h-0 transform-3d">
                                                                    <div :class="{'chip-pulse opacity-75':submiting.z>0}" class="position-absolute">
                                                                        <div v-for="j,index in chipsConvert(submited[currRebate].z+submiting.z)" :key="j" :style="'bottom:'+(0.2*index)+'rem !important'" class="position-absolute translate-middle-x fs-6 text-black" :class="{'chips-img-shadow':index==0}">
                                                                            <chip :foot-class="['bg-'+j]" :face-class="['bg-'+j]" :chip-text="$root.chipsTxtConvert(j)"></chip>
                                                                            <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div v-if="submited[currRebate].z+submiting.z>0" :class="[roomInfo.isar==1&&!isMultiple?'anim-updown-3d':'anim-updown']" class="position-absolute text-black fw-bold fs-6 bottom-0 p-2 rounded-circle bubble" style="transform:translateX(-50%) translateZ(3rem) rotateX(-50deg) translateZ(-2.5rem);">
                                                                        <span class="d-block scale pt-100 h-0">
                                                                            <span class="visibility-hidden" :class="{'fs-scale-1_2rem':isScaleAmount.z}">{{submited[currRebate].z+submiting.z>0?submited[currRebate].z+submiting.z:''}}</span>
                                                                            <small :class="{'text-danger':submited[currRebate].z+submiting.z<limitred.z.split('-')[0]}" class="text-shadow-white position-absolute top-50 start-50 translate-middle">{{submited[currRebate].z+submiting.z>0?submited[currRebate].z+submiting.z:''}}</small>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <!-- 池额 -->
                                                                <div @click.stop :class="{'rotate-sm-x-_50-z-4px':pool.z>0&&roomInfo.isar==1&&!isMultiple}" class="position-absolute bottom-0 end-0 transform-bottom">
                                                                    <div @mousemove="isShowPoolText=true" @mouseout="isShowPoolText=false" class="progress-ring fs-_8rem d-flex justify-content-center align-items-center position-relative rounded-pill overflow-hidden" :style="{background: 'conic-gradient(#00e5ff calc('+((pool.z/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100||0).toFixed()+'%')+'), #787878 0)'}">
                                                                        <div :class="{'progress-text-show':isShowPoolText}" class="progress-text text-light h-1_5rem d-flex justify-content-center align-items-center m-_15rem">
                                                                            <span>{{(pool.z/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100||0).toFixed()}}<span class="fs-_5rem">%</span></span>
                                                                            <span class="px-2">{{ pool.z }}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- 更多筹区 -->
                                                    <change-amount :class="{'rounded-sm-10':!isMultiple}" :is-show="isShowMoreAmount"></change-amount>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 按钮区 -->
                                    <div class="d-flex justify-content-between text-nowrap order-3 mb-1 mb-sm-0 px-1" :class="{'ps-sm-0 pe-sm-2':isMultiple,'justify-content-sm-around px-sm-0 ms-sm-2 flex-sm-column':!isMultiple}">
                                        <div :class="{'position-sm-absolute start-100 bottom-0':!isMultiple}" class="form-check form-switch d-flex align-items-center border border-1 border-secondary rounded p-1 mb-0">
                                            <label class="me-1 text-light" for="cboRebateNewXs">{{$t("room.unRebate")}}</label>
                                            <input class="form-check-input fs-3 m-0" type="checkbox" id="cboRebateNewXs" @change="setRebate($event)" :checked="currRebate==REBATE_TYPE.noRebate">
                                        </div>

                                        <!-- <button class="btn btn-primary bg-gradient text-light btn-shadow-right-primary" :class="{'mb-sm-1':roomInfo.isar==1&&!isMultiple}" type="button" @click="submitEvent('multiple')">{{isMultiple?$t("room.singleRoom"):$t("room.multipleRoom")}}</button> -->
                                        <button class="btn bg-gradient text-light opacity-100 mb-sm-2" :class="{'disabled btn-secondary':!canClear,'btn-shadow-right-secondary':roomInfo.isar==1&&!canClear,'btn-shadow-right-secondary-mini':(roomInfo.isar!=1&&!canClear)||isMultiple,'btn-warning':canClear,'btn-shadow-right-warning':roomInfo.isar==1&&canClear,'btn-shadow-right-warning-mini':roomInfo.isar!=1&&canClear,'mb-sm-1':roomInfo.isar==1&&!isMultiple,'mb-sm-2':roomInfo.isar!=1&&!isMultiple}" :disabled="!canClear" @click="submitEvent('clear')">{{$t("room.clear")}}</button>
                                        <button class="btn bg-gradient text-light opacity-100 mb-sm-2" :class="{'disabled btn-secondary':!canCancel,'btn-shadow-right-secondary':roomInfo.isar==1&&!canCancel,'btn-shadow-right-secondary-mini':(roomInfo.isar!=1&&!canCancel)||isMultiple,'btn-danger':canCancel,'btn-shadow-right-danger':roomInfo.isar==1&&canCancel,'btn-shadow-right-danger-mini':roomInfo.isar!=1&&canCancel,'mb-sm-1':roomInfo.isar==1&&!isMultiple,'mb-sm-2':roomInfo.isar!=1&&!isMultiple}" :disabled="!canCancel" @click="submitEvent('cancel')">{{$t("room.cancel")}}</button>
                                        <button class="btn bg-gradient text-light opacity-100 mb-sm-2" :class="{'disabled btn-secondary':!canConfirm,'btn-shadow-right-secondary':roomInfo.isar==1&&!canConfirm,'btn-shadow-right-secondary-mini':(roomInfo.isar!=1&&!canConfirm)||isMultiple,'btn-success':canConfirm,'btn-shadow-right-success':roomInfo.isar==1&&canConfirm,'btn-shadow-right-success-mini':roomInfo.isar!=1&&canConfirm}" :disabled="!canConfirm" @click="submitEvent('confirm')">{{$t("room.confirm")}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 牌区 -->
                        <div v-if="showPokerArr.length>0" :class="[isShowPokerLayer?'d-flex':'d-none d-sm-flex',isMultiple?'top-sm-6rem transform-left-center scale-sm-_8 ms-sm-1':'top-sm-26 ms-sm-2']" class="position-absolute top-xs-0 index-12 w-xs-100 h-xs-100 align-items-center align-items-sm-start justify-content-center justify-content-sm-start bg-xs-dark bg-opacity-75 rounded-sm-10 text-start">
                            <div v-for="(item,i) in showPokerArr" :key="item" :class="[roomInfo.game==GAME_ID.bac?'order-'+(showPokerArr.length-i):'']" :style="{'background':(i==0?'linear-gradient('+(roomInfo.game==GAME_ID.bac?90:270)+'deg,#910000, rgb(251, 36, 1) 40%)':'linear-gradient('+(roomInfo.game==GAME_ID.bac?270:90)+'deg,#00315d,rgb(0, 105, 197) 40%)')}" class="d-flex flex-column rounded">
                                <div :class="[isMultiple?'pt-1 pt-sm-0 small-sm':'pt-1']" class="text-light text-center fw-bold rounded position-relative fs-xs-5">
                                    <span>{{roomInfo.game==GAME_ID.bac?i==0?$t("common.z"):$t("common.x"):i==0?$t("common.l"):$t("common.hu")}}</span>
                                    <i class="position-absolute fw-bold fs-xs-1 fs-sm-4 lh-1" :class="{'end-0':(roomInfo.game==GAME_ID.bac&&i!=0)||(roomInfo.game!=GAME_ID.bac&&i==0),'start-0':(roomInfo.game==GAME_ID.bac&&i==0||roomInfo.game!=GAME_ID.bac&&i!=0)}" :style="{'color':i==0?COLOR.red:COLOR.blue}">{{ roomInfo.game==GAME_ID.bac?(i==0?'S':'V'):(i==0?'V':'S') }}</i>
                                    <span v-if="isPokerWin(i)&&isShowPokerCompare" class="bi bi-trophy-fill text-yellow position-absolute translate-middle-y top-50 big-scale-small fs-xs-1 fs-sm-4" :class="{'start-0':(roomInfo.game==GAME_ID.bac&&i!=0)||(roomInfo.game!=GAME_ID.bac&&i==0),'end-0':(roomInfo.game==GAME_ID.bac&&i==0||roomInfo.game!=GAME_ID.bac&&i!=0)}"></span>
                                </div>
                                <div :class="[isMultiple?'w-sm-5rem h-sm-6rem':'w-sm-7rem h-sm-8rem']" class="rounded p-1 d-flex flex-wrap justify-content-between align-items-end position-relative w-10rem h-11rem">
                                    <!-- 牌 -->
                                    <div v-for="(val,j) in item" :key="val" class="d-flex align-items-center justify-content-center" :class="[item.length==3&&j==2?'w-100 order-1':'order-2']">
                                        <div v-if="val" :class="[$root.getPokerByNum(val)['color'],((i+1)==currPokerXY[0]&&(j+1)==currPokerXY[1])?'rotate':'',j==2?'':'flex-column',isMultiple?'small-sm p-xs-1 p-sm-_125rem':'p-1']" class="d-flex bg-light rounded ">
                                            <span class="fw-bold lh-1 fs-xs-5 small" :class="{'order-1 text-vertical':j==2}">{{ $root.getPokerByNum(val)["name"] }}</span>
                                            <div class="d-flex flex-grow-1" :class="[j==2?'py-3 py-sm-2 pe-2 pe-sm-1 ps-3 ps-sm-2':'px-3 px-sm-2 pt-2 pt-sm-1 pb-3 pb-sm-2']">
                                                <i :class="[$root.getPokerByNum(val)['shape'],j==2?'rotate-90':'',isMultiple?'':'fs-sm-4']" class="bi d-flex align-items-center justify-content-center fs-xs-2 flex-grow-1"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="isShowPokerCompare" class="position-absolute top-50 start-50 translate-middle init-rotate-345 border-double border-dark px-1 rounded fw-bold text-nowrap big-scale-small">{{ getPoint(item) }}点</div>
                                </div>
                            </div>
                            <div class="d-sm-none position-absolute top-0 end-0 pt-2 pe-2">
                                <i @click="isShowPokerLayer=false" class="d-flex bi bi-x-octagon text-light fs-3"></i>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <!-- 路单统计区 -->
            <!-- <div v-if="!isMultiple" class="d-flex flex-wrap justify-content-between text-light pe-2 small bg-gradient">
                <div class="ps-2">{{$root.getTextByGame("common.",roomInfo.game,0)}}：{{pearlCount.z}}</div>
                <div class="ps-2">{{$root.getTextByGame("common.",roomInfo.game,1)}}：{{pearlCount.x}}</div>
                <div class="ps-2">{{$t("common.h")}}：{{pearlCount.h}}</div>
                <div class="ps-2" v-if="roomInfo.game==GAME_ID.bac">{{$t("common.zd")}}：{{pearlCount.zd}}</div>
                <div class="ps-2" v-if="roomInfo.game==GAME_ID.bac">{{$t("common.xd")}}：{{pearlCount.xd}}</div>
                <div class="d-flex col-12 col-sm-auto fw-bold">
                    <div class="ps-2 col-6 col-sm-auto d-flex">
                        <span class="text-danger">{{$root.getTextByGame("room.next",roomInfo.game,0)}}：</span>
                        <label class="d-flex align-items-center text-transparent">
                            <span class="rounded-circle w-1rem h-1rem border-2 border-solid me-2" :style="nextZHollowStyle"></span>
                            <span class="h-1rem border-1 border-top-0 border-left-0 border-bottom-0 rotate-30 border-solid me-2" :style="nextZBevelStyle"></span>
                            <span class="rounded-circle w-1rem h-1rem border-3" :style="nextZSolidStyle"></span>
                        </label>
                    </div>
                    <div class="ps-2 col-6 col-sm-auto d-flex justify-content-end">
                        <span :style="'color:'+COLOR.blue">{{$root.getTextByGame("room.next",roomInfo.game,1)}}：</span>
                        <label class="d-flex align-items-center text-transparent">
                            <span class="rounded-circle w-1rem h-1rem border-2 border-solid me-2" :style="nextXHollowStyle"></span>
                            <span class="h-1rem border-1 border-top-0 border-left-0 border-bottom-0 rotate-30 border-solid me-2" :style="nextXBevelStyle"></span>
                            <span class="rounded-circle w-1rem h-1rem border-3" :style="nextXSolidStyle"></span>
                        </label>
                    </div>
                </div>
            </div> -->
            <!-- 路单区 -->
            <div v-if="!isMultiple" class="flex-grow-1 d-flex flex-column flex-sm-row h-0 position-relative" :class="[(gameModel==GAME_MODEL.normal)?'flex-sm-grow-0 h-sm-7rem':'overflow-hidden']">
                <!-- 问路 -->
                <!-- <div class="d-flex flex-column text-light text-center w-2rem text-nowrap small">
                    <div @click="nextPrediction(roomInfo.game==GAME_ID.bac?'A':'M')" :style="'background:'+COLOR.red+';border-color:'+COLOR.red" class="d-flex justify-content-center align-items-center col text-vertical small bg-highlight border-_3 border-style-outset" role="button">{{$root.getTextByGame("room.will",roomInfo.game,0)}}</div>
                    <div @click="nextPrediction(roomInfo.game==GAME_ID.bac?'B':'N')" :style="'background:'+COLOR.blue+';border-color:'+COLOR.blue" class="d-flex justify-content-center align-items-center col text-vertical small bg-highlight border-_3 border-style-outset" role="button">{{$root.getTextByGame("room.will",roomInfo.game,1)}}</div>
                </div> -->
                <!-- 路单信息区 -->
                <div class="d-flex flex-wrap flex-sm-nowrap flex-sm-column w-xs-100 w-5rem">
                    <!-- 问路和预测 -->
                    <div class="flex-grow-1 d-flex align-item-center fs-_6rem small-xs text-light">
                        <div class="col d-flex flex-sm-column">
                            <span @click="nextPrediction(roomInfo.game==GAME_ID.bac?'A':'M')" class="col btn-danger bg-gradient d-flex align-items-center justify-content-center" role="button">{{$root.getTextByGame("room.will",roomInfo.game,0)}}</span>
                            <div class="col d-flex justify-content-evenly align-items-center text-transparent border border-danger border-top-sm-0">
                                <span class="rounded-circle w-_8rem h-_8rem border-2 border-solid" :style="nextZHollowStyle"></span>
                                <span class="h-_8rem border-1 border-top-sm-0 border-left-0 border-bottom-0 rotate-30 border-solid" :style="nextZBevelStyle"></span>
                                <span class="rounded-circle w-_8rem h-_8rem" :style="nextZSolidStyle"></span>
                            </div>
                        </div>
                        <div class="col d-flex flex-sm-column">
                            <span @click="nextPrediction(roomInfo.game==GAME_ID.bac?'B':'N')" class="col btn-primary bg-gradient d-flex align-items-center justify-content-center">{{$root.getTextByGame("room.will",roomInfo.game,1)}}</span>
                            <div class="col d-flex justify-content-evenly align-items-center text-transparent border border-primary border-top-sm-0">
                                <span class="rounded-circle w-_8rem h-_8rem border-2 border-solid" :style="nextXHollowStyle"></span>
                                <span class="h-_8rem border-1 border-top-sm-0 border-left-0 border-bottom-0 rotate-30 border-solid" :style="nextXBevelStyle"></span>
                                <span class="rounded-circle w-_8rem h-_8rem" :style="nextXSolidStyle"></span>
                            </div>
                        </div>
                    </div>
                    <!-- 统计 -->
                    <div class="d-flex flex-sm-column text-light fs-_6rem small-xs w-xs-100">
                        <div class="col d-flex justify-content-between align-items-center overflow-hidden">
                            <div class="bg-gradient w-3rem w-sm-2_4rem text-center skew-x--45 ms--_5rem index-1" :style="{background:COLOR.red}" style="box-shadow: 0 0 .2rem #000;">
                                <span class="skew-x-45 d-block">{{$root.getTextByGame("common.",roomInfo.game,0)}}</span>
                            </div>
                            <div class="flex-grow-1 skew-x--45 text-center overflow-hidden bg-gradient me--_5rem position-relative">
                                <div class="bg-warning bg-gradient h-100 position-absolute top-0 start-0 skew-x-45 ms--_5rem" :style="{width:getPearlCountPercent(pearlCount.z)}"></div>
                                <span class="skew-x-45 d-block ms--_5rem">{{pearlCount.z}}</span>
                            </div>
                        </div>
                        <div class="col d-flex justify-content-between align-items-center overflow-hidden">
                            <div class="bg-gradient w-3rem w-sm-2_4rem text-center skew-x--45 ms--_5rem index-1" :style="{background:COLOR.blue}" style="box-shadow: 0 0 .2rem #000;">
                                <span class="skew-x-45 d-block">{{$root.getTextByGame("common.",roomInfo.game,1)}}</span>
                            </div>
                            <div class="flex-grow-1 skew-x--45 text-center overflow-hidden bg-gradient me--_5rem position-relative">
                                <div class="bg-warning bg-gradient h-100 position-absolute top-0 start-0 skew-x-45 ms--_5rem" :style="{width:getPearlCountPercent(pearlCount.x)}"></div>
                                <span class="skew-x-45 d-block ms--_5rem">{{pearlCount.x}}</span>
                            </div>
                        </div>
                        <div class="col d-flex justify-content-between align-items-center overflow-hidden">
                            <div class="bg-gradient w-3rem w-sm-2_4rem text-center skew-x--45 ms--_5rem index-1" :style="{background:COLOR.green}" style="box-shadow: 0 0 .2rem #000;">
                                <span class="skew-x-45 d-block">{{$t("common.h")}}</span>
                            </div>
                            <div class="flex-grow-1 skew-x--45 text-center overflow-hidden bg-gradient me--_5rem position-relative">
                                <div class="bg-warning bg-gradient h-100 position-absolute top-0 start-0 skew-x-45 ms--_5rem" :style="{width:getPearlCountPercent(pearlCount.h)}"></div>
                                <span class="skew-x-45 d-block ms--_5rem">{{pearlCount.h}}</span>
                            </div>
                        </div>
                        <div v-if="roomInfo.game==GAME_ID.bac" class="col d-flex justify-content-between align-items-center overflow-hidden">
                            <div class="bg-gradient w-3rem w-sm-2_4rem text-center skew-x--45 ms--_5rem index-1" :style="{background:COLOR.redDark}" style="box-shadow: 0 0 .2rem #000;">
                                <span class="skew-x-45 d-block">{{$t("common.zd")}}</span>
                            </div>
                            <div class="flex-grow-1 skew-x--45 text-center overflow-hidden bg-gradient me--_5rem position-relative">
                                <div class="bg-warning bg-gradient h-100 position-absolute top-0 start-0 skew-x-45 ms--_5rem" :style="{width:getPearlCountPercent(pearlCount.zd)}"></div>
                                <span class="skew-x-45 d-block ms--_5rem">{{pearlCount.zd}}</span>
                            </div>
                        </div>
                        <div v-if="roomInfo.game==GAME_ID.bac" class="col d-flex justify-content-between align-items-center overflow-hidden">
                            <div class="bg-gradient w-3rem w-sm-2_4rem text-center skew-x--45 ms--_5rem index-1" :style="{background:COLOR.blueDark}" style="box-shadow: 0 0 .2rem #000;">
                                <span class="skew-x-45 d-block">{{$t("common.xd")}}</span>
                            </div>
                            <div class="flex-grow-1 skew-x--45 text-center overflow-hidden bg-gradient me--_5rem position-relative">
                                <div class="bg-warning bg-gradient bg-gradient h-100 position-absolute top-0 start-0 skew-x-45 ms--_5rem" :style="{width:getPearlCountPercent(pearlCount.xd)}"></div>
                                <span class="skew-x-45 d-block ms--_5rem">{{pearlCount.xd}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-grow-1 h-xs-0 h-sm-100 position-relative">
                    <!-- 路单 -->
                    <div :class="{'flex-sm-nowrap':pearlModel==1,'flex-column':pearlModel==2}" class="flex-grow-1 d-flex flex-wrap w-0">
                        <div :class="{'col-6 col-sm-3 h-xs-50 h-sm-100':pearlModel==1,'h-xs-33 col-sm-3 h-sm-100':pearlModel==2}" class="position-relative">
                            <canvas id="textBigPearl" class="bg-light d-block mx-auto min-w-100 min-h-100 mw-100 mh-100" v-set-size="6" data-canvas-room="6" width="0" height="0" @mousemove.stop="showPoker($event,1)"></canvas>
                            <div class="bg-dark bg-opacity-25 position-absolute" :style="pearlLayerStyle" @mouseout.stop="showPoker($event,0)"></div>
                            <div v-if="isShowPearlMoreLayer" class="d-flex justify-content-center bg-dark bg-opacity-75 position-absolute top-0 start-0 w-100 h-100 text-light hover-bg-opacity-50">
                                <div class="d-flex flex-column justify-content-center">
                                    <i class="d-flex bi bi-arrows-fullscreen p-2 fs-5" @click="showMorePearl(PEARL_TYPE.big_text)" role="button"></i>
                                </div>
                            </div>
                        </div>
                        <div :class="{'col-6 col-sm-3 h-xs-50 h-sm-100':pearlModel==1,'h-xs-33 col-sm-9 h-sm-50':pearlModel==2}" class="position-relative">
                            <canvas id="bigPearl" class="bg-light d-block min-w-100 min-h-100 mw-100 mh-100" v-set-size="6" data-canvas-room="6" width="0" height="0"></canvas>
                            <div v-if="isShowPearlMoreLayer" class="d-flex justify-content-center bg-dark bg-opacity-75 position-absolute top-0 start-0 w-100 h-100 text-light hover-bg-opacity-50">
                                <div class="d-flex flex-column justify-content-center">
                                    <i class="d-flex bi bi-arrows-fullscreen p-2 fs-5" @click="showMorePearl(PEARL_TYPE.big_hollow)" role="button"></i>
                                </div>
                            </div>
                        </div>
                        <div :class="{'col-12 col-sm-6 h-xs-50 h-sm-100':pearlModel==1,'h-xs-33 col-sm-9 h-sm-50':pearlModel==2}" class="d-flex flex-column">
                            <div class="d-flex h-50">
                                <div class="col-6 position-relative">
                                    <canvas id="smallHollowPearl" class="bg-light d-block min-w-100 min-h-100 mw-100 mh-100" v-set-size="3" data-canvas-room="3" width="0" height="0"></canvas>
                                    <div v-if="isShowPearlMoreLayer" class="d-flex justify-content-center bg-dark bg-opacity-75 position-absolute top-0 start-0 w-100 h-100 text-light hover-bg-opacity-50">
                                        <div class="d-flex flex-column justify-content-center">
                                            <i class="d-flex bi bi-arrows-fullscreen p-2 fs-5" @click="showMorePearl(PEARL_TYPE.small_hollow)" role="button"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6 position-relative">
                                    <canvas id="smallSolidPearl" class="bg-light d-block min-w-100 min-h-100 mw-100 mh-100" v-set-size="3" data-canvas-room="3" width="0" height="0"></canvas>
                                    <div v-if="isShowPearlMoreLayer" class="d-flex justify-content-center bg-dark bg-opacity-75 position-absolute top-0 start-0 w-100 h-100 text-light hover-bg-opacity-50">
                                        <div class="d-flex flex-column justify-content-center">
                                            <i class="d-flex bi bi-arrows-fullscreen p-2 fs-5" @click="showMorePearl(PEARL_TYPE.small_solid)" role="button"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex h-50">
                                <div class="col-6 position-relative">
                                    <canvas id="bevelPearl" class="bg-light d-block min-w-100 min-h-100 mw-100 mh-100" v-set-size="3" data-canvas-room="3" width="0" height="0"></canvas>
                                    <div v-if="isShowPearlMoreLayer" class="d-flex justify-content-center bg-dark bg-opacity-75 position-absolute top-0 start-0 w-100 h-100 text-light hover-bg-opacity-50">
                                        <div class="d-flex flex-column justify-content-center">
                                            <i class="d-flex bi bi-arrows-fullscreen p-2 fs-5" @click="showMorePearl(PEARL_TYPE.bevel)" role="button"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6 position-relative">
                                    <canvas id="threePearl" class="bg-light d-block min-w-100 min-h-100 mw-100 mh-100" v-set-size="3" data-canvas-room="3" width="0" height="0"></canvas>
                                    <div v-if="isShowPearlMoreLayer" class="d-flex justify-content-center bg-dark bg-opacity-75 position-absolute top-0 start-0 w-100 h-100 text-light hover-bg-opacity-50">
                                        <div class="d-flex flex-column justify-content-center">
                                            <i class="d-flex bi bi-arrows-fullscreen p-2 fs-5" @click="showMorePearl(PEARL_TYPE.big_three)" role="button"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 功能 -->
                    <div class="d-flex flex-column flex-sm-row small text-light">
                        <!-- 切换模式 -->
                        <div v-if="!isShowPearlMoreLayer" class="col d-flex flex-column justify-content-center align-items-center px-1 bg-dark bg-opacity-75 border-_3 border-style-outset border-dark small bg-gradient" @click="pearlModel=pearlModel==1?2:1" role="button">
                            <i class="bi bi-arrow-left-right lh-1 mb-lg-1"></i>
                            <div class="d-flex flex-column align-items-center">
                                <span class="text-vertical">{{$t('room.toggleMode')}}</span>
                            </div>
                        </div>
                        <!-- 查看全部按钮 -->
                        <div class="col d-flex flex-column justify-content-center align-items-center px-1 bg-dark bg-opacity-75 border-_3 border-style-outset border-dark small bg-gradient" @click="isShowPearlMoreLayer=!isShowPearlMoreLayer" role="button">
                            <i v-show="!isShowPearlMoreLayer" class="bi bi-search lh-1 mb-lg-1"></i>
                            <i v-show="isShowPearlMoreLayer" class="bi bi-x-octagon lh-1 mb-lg-1"></i>
                            <div class="d-flex flex-column align-items-center">
                                <span v-show="!isShowPearlMoreLayer" class="text-vertical">{{$t("room.viewAll")}}</span>
                                <span v-show="isShowPearlMoreLayer" class="text-vertical">{{$t("common.close")}}</span>
                            </div>
                        </div>
                    </div>
                    <!-- 查看所有路单 -->
                    <div :class="{'d-none':pearlMoreType==null}" class="position-absolute start-0 top-0 w-100 h-100">
                        <div class="w-100 h-100 bg-light">
                            <canvas id="fullPearl" v-move-x class="bg-light d-block min-w-100 min-h-100 mh-100 position-absolute end-0" width="0" height="0"></canvas>
                        </div>
                        <div class="position-absolute top-50 start-0 translate-middle-y p-2">
                            <i class="bi bi-caret-left-square-fill opacity-50 fs-1" @click="movePearlMore(-1)" role="button"></i>
                        </div>
                        <div class="position-absolute top-50 end-0 translate-middle-y p-2">
                            <i class="bi bi-caret-right-square-fill opacity-50 fs-1" @click="movePearlMore(1)" role="button"></i>
                        </div>
                        <div class="position-absolute bottom-0 start-50 translate-middle-x p-2">
                            <i class="d-flex bi bi-x-circle-fill opacity-75 fs-2" @click="pearlMoreType=null" role="button"></i>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 多台 -->
            <div @click="submitEvent('multiple')" class="d-flex position-absolute top-38 end-0 text-vertical bg-danger text-light rounded-start border border-2 border-warning border-end-0 lh-sm px-1 py-2 index-13" role="button">
                <span>{{isMultiple?$t("room.singleRoom"):$t("room.multipleRoom")}}</span>
            </div>
            <!-- 换台区 -->
            <change-room v-if="!isMultiple" :class="{'me-sm-0':roomInfo.isar==1}" :room-list="roomList" :count-list="countList" :pearl-obj="pearlObj"></change-room>
            <!-- 音效 -->
            <audio-player v-show="false" ref="resultAudioPlayer" :isLoop="false" :isAutoPlayNext="false" :muted="!audioSwitch.resultAudio" :audio-list="resultAudioList.map(elm => elm.url)" />
        </div>
    </div>
</template>
<script>
import {COMMAND,COLOR, GAME_ID,PEARL_TYPE,PEARL_CODE,REBATE_TYPE,LAYER_TYPE,SUBMIT_RESULT,CANCEL_RESULT, IS_REBATE,RESULT,RATIO,AMOUTN_ARR,MUTATION_TYPE,GAME_CODE, GAME_MODEL,MARK_TYPE,RULE_TYPE, POKER_TYPE,USER} from "@/assets/js/config.js"
import mediaVideo from "@/components/public/video.vue";
import roomList from '@/components/public/roomList.vue';
import navbarVertical from '@/components/public/navbarVertical.vue';
import navbar from '@/components/public/navbar.vue';
import notice from '@/components/public/notice.vue';
import changeRoom from '@/components/public/changeRoom.vue'
import changeAmount from '@/components/public/changeAmount.vue'
import chip from '@/components/public/chip.vue'
import task from "@/components/public/task.vue";
import { useLayer } from '@/assets/js/useLayer';
import { getDeviceType,formatDate } from '@/assets/js/common.js'
export default {
    components: { 
        mediaVideo,
        roomList,
        changeRoom,
        navbarVertical,
        navbar,
        notice,
        changeAmount,
        chip,
        task,
    },
    directives: {
        'set-size': {
            mounted(elem,binding){
                let _this=binding.instance;
                //设置画布大小
                _this.$root.setCanvasSize(elem);
                //绘制画布表格
                _this.$root.drawCanvasTable(elem,binding.value,false);
            }
        },
        'move-x':{
            mounted(elem,binding){
                let clickFn=(e,fn)=>{
                    elem.classList.add("untransition");
                    let clickX=e.pageX||e.targetTouches[0].pageX;//按下的x坐标
                    let width=getComputedStyle(elem).width.replace('px','');//总宽度
                    let parentWidth=getComputedStyle(elem.parentNode).width.replace('px','');//获取一版宽度
                    let left=Number(getComputedStyle(elem).left.replace('px',''));//左边距
                    fn(clickX,width,parentWidth,left);
                }
                let moveFn=(e,clickX,width,parentWidth,left)=>{
                    let moveX=e.pageX||(e.targetTouches&&e.targetTouches[0].pageX);//移动到的x坐标
                    let moveDistance=moveX-clickX;//移动的距离
                    let newLeft=left+moveDistance;//新的左边距
                    if(newLeft>0){//左边距不能大于0
                        newLeft=0;
                    }else if(Math.abs(newLeft)>width-parentWidth){//左边距不能小于总宽度-一版的宽度
                        newLeft=-(width-parentWidth);
                    }
                    elem.style.left=newLeft+"px";//新左边距=旧左边距+移动的距离
                }
                elem.onmouseup=(e1)=>{
                    elem.classList.remove("untransition");
                }
                elem.onmousedown=(e1)=>{
                    clickFn(e1,(clickX,width,parentWidth,left)=>{
                        document.onmousemove=(e2)=>{
                            moveFn(e2,clickX,width,parentWidth,left);
                        }
                    })
                }
                elem.ontouchstart=(e1)=>{
                    clickFn(e1,(clickX,width,parentWidth,left)=>{
                        document.ontouchmove=(e2)=>{
                            moveFn(e2,clickX,width,parentWidth,left);
                        }
                    })
                }
            }
        }
    },
    props: {
        hasChatMsg:false,//是否有未读的客服消息
        isPageReady:false,//页面是否加载完毕
        isFullscreen:{
            type:Boolean,
            default:false
        },//当前是否全屏
    },
    data() {
        return {
            COMMAND,
            PEARL_TYPE,//获取路单类型配置
            COLOR,//获取颜色配置
            GAME_ID,//获取游戏id列表配置
            REBATE_TYPE,//获取佣金方式配置
            GAME_MODEL,
            MARK_TYPE,//印记类型
            POKER_TYPE,
            IS_REBATE,//是否免佣
            pearlCount:{z:0,x:0,h:0,zd:0,xd:0},//统计
            pearlArr:[],//台面路单列表
            virtualPearlArr:[],//台面问路路单列表
            nextZHollowStyle:"",//下局预测Z空心样式
            nextZBevelStyle:"",//下局预测Z斜线样式
            nextZSolidStyle:"",//下局预测Z实心样式
            nextXHollowStyle:"",//下局预测X空心样式
            nextXBevelStyle:"",//下局预测X斜线样式
            nextXSolidStyle:"",//下局预测X实心样式
            odds:{z:"0",x:"0",h:"0",zd:"0",xd:"0",z6:"0",z26:"0",z36:"0",x7z6:"0"},//赔率
            limitred:{z:"0-0",x:"0-0",h:"0-0",zd:"0-0",xd:"0-0",z6:"0-0",z26:"0-0",z36:"0-0",x7z6:"0-0"},//限红
            pool:{z:0,x:0,zd:0,xd:0,h:0},//池
            coruscateArr:[],//闪烁位集合，存放将要闪烁的位置
            currRebate:REBATE_TYPE.rebate,//当前佣金模式
            amount:10,//选中额度
            currAmountListSort:[10,50,100,500,1000,5000,10000],//排序后的选中额度列表
            submited:[{z:0,x:0,h:0,zd:0,xd:0,z6:0,z26:0,z36:0,x7z6:0},{z:0,x:0,h:0,zd:0,xd:0,z6:0,z26:0,z36:0,x7z6:0}],//当前模式已提交的额度列表
            submiting:{z:0,x:0,h:0,zd:0,xd:0,z6:0,z26:0,z36:0,x7z6:0},//当前模式将要提交的额度列表
            canClear:false,//是否可以点击清除
            canCancel:false,//是否可以点击取消
            canConfirm:false,//是否可以点击确定
            pearlObj: {
                id:0,//台面id
                pearl:[]//路单数据
            },//要重绘路单的对象
            countList:[],//路单统计列表
            isMultiple:false,//是否显示多台
            isShowNextPrediction:false,//当前是否显示着问路
            resultAudioList:[
                {
                    url:require('@/assets/media/baccarat/win_he.mp3')
                },
                {
                    url:require('@/assets/media/baccarat/win_hu.mp3')
                },
                {
                    url:require('@/assets/media/baccarat/win_l.mp3')
                },
                {
                    url:require('@/assets/media/baccarat/win_x.mp3')
                },
                {
                    url:require('@/assets/media/baccarat/win_z.mp3')
                }
            ],//开结果音效
            pokerArr:[],//当前台面牌组
            showPokerArr:[],//要显示的牌组
            currPokerXY:[0,0],//当前要翻转的扑克
            pearlLayerStyle:{
                width:0,
                height:0,
                left:0,
                top:0,
                display:'none'
            },//鼠标移上路单的遮罩层
            point:[0,0],//鼠标在路单上的坐标点
            videoList:[],//视频线路地址，当前支持最多两个
            isShowMoreAmount:false,//是否显示更多筹码
            isShowPoker:true,//鼠标移入画布是否显示牌
            isShowPokerCompare:true,//是否显示牌的大小比较
            isShowPokerLayer:true,//是否显示牌
            isModuleReady:false,//页面内组件是否加载完成
            isShowPearlMoreLayer:false,//是否显示查看全部路单遮罩层
            pearlMoreType:null,//当前显示的全部路单数据的类型
            pearlModel:1,//路子模式（1:模式1 2:模式2）
            readyVideoIdArr:[],//已加载好的视频id
            showPokerTimer:null,//显示牌计时器
            isShowMark:false,//是否显示连中印记
            isShowGetMark:false,//是否显示得到印记动画
            lastVideoLine:"",//上一次获取视频的视频线路id
            //新版台参数
            isScale:false,//是否放大提交区和视频区
            isScaleAmount:{z:false,x:false,h:false,zd:false,xd:false},//是否放大码额
            isShowTask:true,//是否显示所有活动任务图标
            isShowPoolText:false,//是否显示池具体值
        };
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        roomInfo() {
            return this.$store.state.roomInfo;
        },
        tabGame(){
            return this.$store.state.tabGame;
        },
        currVideoLine(){
			return this.$store.state.currVideoLine;
		},
        audioSwitch(){
            return this.$store.state.audioSwitch;
        },
        gameModel(){
            return this.$store.state.gameModel;
        },
        videoLineList(){
            return this.$store.state.videoLineList;
        },
        currAmountList(){
            return this.$store.state.currAmountList;
        },
        userAmountList(){
            return this.$store.state.userAmountList;
        },
        roomList(){
            return this.$store.state.roomList;
        },
        tableColumnList(){
            return this.$store.state.tableColumnList;
        },
        /**
         * 是否有点数玩法
         */
        hasPointMode(){
            return (this.roomInfo.isar==1&&this.roomInfo.pokermode!=POKER_TYPE.show&&this.roomInfo.game==GAME_ID.bac)?true:false;
        }
    },
    mounted() {
        layer.closeAll();
        this.init();
        this.setWsMessage();
        addEventListener("resize",this.setResize);
    },
    unmounted() {
        removeEventListener("resize",this.setResize);
        delete this.$root.wsMsgObj["bac"];
    },
    methods: {
        init(){
            //获取台面视频
            if(this.currVideoLine==""){
                useLayer({str:this.$t("video.noVideoLine")});
            }else{
                // this.$emit("ws-send",COMMAND.all_getvideo,this.roomInfo.id,this.currVideoLine,this.userInfo.id,this.userInfo.guid);
                this.$root.wsSendJson({
                    command:COMMAND.all_getvideo,
                    tableId:this.roomInfo.id,
                    lineId:this.currVideoLine,
                    userid:this.userInfo.id,
                    guid:this.userInfo.guid
                });
                this.lastVideoLine=this.currVideoLine;
            }
            if(this.roomInfo.pokermode==POKER_TYPE.normal){//普通台正常获取赔率，明牌台需要获取牌之后再获取赔率
                // this.$emit("ws-send",COMMAND.bac_getodds,this.roomInfo.id,this.userInfo.id,this.userInfo.guid);
                this.$root.wsSendJson({
                    command:COMMAND.bac_getodds,
                    tableId:this.roomInfo.id,
                    userid:this.userInfo.id,
                    guid:this.userInfo.guid
                });
            }
            //获取限红
            // this.$emit("ws-send",COMMAND.bac_getlimitred,this.userInfo.id,this.userInfo.guid);
            this.$root.wsSendJson({
                command:COMMAND.bac_getlimitred,
                userid:this.userInfo.id,
                guid:this.userInfo.guid
            });
            //获取各位置已提交额度
            // this.$emit("ws-send",COMMAND.bac_getbetdetail,this.roomInfo.id,this.roomInfo.boot,this.roomInfo.innings,this.userInfo.id,this.userInfo.guid);
            this.$root.wsSendJson({
                command:COMMAND.bac_getbetdetail,
                tableId:this.roomInfo.id,
                boot:this.roomInfo.boot,
                innings:this.roomInfo.innings,
                userid:this.userInfo.id,
                guid:this.userInfo.guid
            });
            //获取台面路单
            this.$root.getRoomPearl(this.roomInfo.game,this.roomInfo.id);
            //获取台面扑克
            // this.$emit("ws-send",COMMAND.bac_getroompoker, this.roomInfo.id,this.roomInfo.boot,-1,this.userInfo.id, this.userInfo.guid);
            this.$root.wsSendJson({
                command:COMMAND.bac_getroompoker,
                tableId:this.roomInfo.id,
                boot:this.roomInfo.boot,
                number:-1,
                userid:this.userInfo.id,
                guid:this.userInfo.guid
            });
            //获取池额
            this.$root.wsSendJson({
                command:COMMAND.bac_receivepool,
                tableId:this.roomInfo.id,
                userid:this.userInfo.id,
                guid:this.userInfo.guid
            });
            // //获取玩法配置信息
            // this.$emit("ws-send",COMMAND.all_getrule,RULE_TYPE.mark, this.userInfo.id,this.userInfo.guid);
            //不能免佣则重置佣金模式为非免佣
            this.roomInfo.iscommission==IS_REBATE.false&&(this.currRebate=REBATE_TYPE.rebate);
        },
        /**
         * 设置websocket响应事件
         */
        setWsMessage(){
            this.$root.wsMsgObj["bac"]=(data)=>{
                switch (data.command) {
                    case COMMAND.all_getroompearl:
                        if(data.id==this.roomInfo.id){//获取的是当前台面的数据
                            this.pearlArr=data.pearl;
                        }
                        if(this.roomList&&this.roomList.find(v=>v.id==data.id)){//用于切换台面功能获取数据，换台列表中有才需要更新
                            this.pearlObj={
                                id:data.id,
                                pearl:data.pearl
                            }
                            this.countList[data.id]=data.count;
                        }
                        break;
                    case COMMAND.all_getvideo:
                        let videoArr=data.video;
                        let list=[];//拼装好的视频地址数组
                        for (let i = 0; i < videoArr.length; i++) {
                            list.push(data.flvline+'/'+videoArr[i]+'.flv');
                        }
                        this.videoList=list;
                        break;
                    case COMMAND.bac_getodds:
                        if(this.roomInfo.pokermode==POKER_TYPE.show){//明牌模式
                            this.odds={
                                z:0,
                                x:0,
                                h:0,
                                zd:0,
                                xd:0,
                                z6:0,
                                z26:0,
                                z36:0,
                                x7z6:0
                            }
                            if(this.showPokerArr.length>0&&(this.showPokerArr[0][0]||this.showPokerArr[1][0])){//任意一张牌出了，才能算赔率
                                let zNum=this.showPokerArr[0][0]?this.$root.getPokerByNum(this.showPokerArr[0][0]).name:3;//z没牌算3
                                let xNum=this.$root.getPokerByNum(this.showPokerArr[1][0]).name;
                                // let str="z"+((zNum<=6||zNum=='A')?6: (zNum>6&&zNum<=9)?zNum:0 )+"x"+((xNum<=6||xNum=='A')?6: (xNum>6&&xNum<=9)?xNum:0 );//拼个字符串，好匹配key
                                let str="z"+(zNum=='A'?1:(zNum<=9?zNum:0))+"x"+(xNum=='A'?1:(xNum<=9?xNum:0));//拼个字符串，好匹配key
                                let odd = data.odds.find(v=>v.key==str);
                                this.odds.z=odd.os[0];
                                this.odds.x=odd.os[1];
                                this.odds.h=odd.os[2];
                                this.odds.zd=odd.os[3];
                                this.odds.xd=odd.os[3];
                                this.odds.z6=odd.os[4];
                                this.odds.z26=odd.os[5];
                                this.odds.z36=odd.os[6];
                                this.odds.x7z6=odd.os[7];
                            }
                        }else if(this.roomInfo.pokermode==POKER_TYPE.normal){//正常模式
                            this.odds={
                                z:data.odds.z,
                                x:data.odds.x,
                                h:data.odds.h,
                                zd:data.odds.zd,
                                xd:data.odds.xd,
                                z6:data.odds.z1,
                                z26:data.odds.z2,
                                z36:data.odds.x1,
                                x7z6:data.odds.x2
                            }
                        }
                        break;
                    case COMMAND.bac_getlimitred:
                        this.limitred={
                            z:data.limitred.z,
                            x:data.limitred.x,
                            h:data.limitred.h,
                            zd:data.limitred.zd,
                            xd:data.limitred.xd,
                            z6:data.limitred.z1,
                            z26:data.limitred.z2,
                            z36:data.limitred.x1,
                            x7z6:data.limitred.x2
                        }
                        this.autoAmount();
                        // //配置额度规则：永远保留10，最高小于两千保留20，最高小于一万保留50 最低在一千以下则保留100，
                        // let max=data.limitred.z.split('-')[1];
                        // if (max<=2000) {
                        //     this.currAmountListSort=[10,20,50,100,200,500,1000];
                        // }else if(max>2000&&max<=5000){
                        //     this.currAmountListSort=[10,50,100,200,500,1000,2000];
                        // }else if(max>5000&&max<=10000){
                        //     this.currAmountListSort=[10,100,200,500,1000,2000,5000];
                        // }else if(max>10000&&max<=20000){
                        //     this.currAmountListSort=[10,100,200,500,1000,5000,10000];
                        // }else if(max>20000&&max<=100000){
                        //     this.currAmountListSort=[10,100,500,1000,5000,10000,20000];
                        // }

                        //设置额度，优先取与限红一致的额度，个数超出则去除，不够则补足
                        // let limitredArr=Object.values(this.limitred).map(v=>v.split('-')).flat(Infinity);
                        // let noRepeatArr=[];//去掉重复项后的限红数组
                        // let chooseArr=[];//筛选出的额度数组
                        // for (let i = 0; i < limitredArr.length; i++) {//限红去重
                        //     noRepeatArr.indexOf(limitredArr[i])==-1&&noRepeatArr.push(limitredArr[i]);
                        // }
                        // for (let i = 0; i < AMOUTN_ARR.length; i++) {//挑选与限红一样的额度
                        //     noRepeatArr.indexOf(String(AMOUTN_ARR[i]))!=-1&&chooseArr.push(AMOUTN_ARR[i]);
                        // }
                        // if(chooseArr.length>7){//多于7个
                        //     this.currAmountListSort=chooseArr.slice(0,7);//取前5个
                        // }else if(chooseArr.length<7){//少于7个，等于7个不考虑
                        //     for (let i = 0; i < AMOUTN_ARR.length; i++) {//用额度列表中的额度补足
                        //         chooseArr.indexOf(AMOUTN_ARR[i])==-1&&chooseArr.push(AMOUTN_ARR[i]);
                        //         if(chooseArr.length==7){
                        //             break;
                        //         }
                        //     }
                        //     this.currAmountListSort=chooseArr;
                        // }
                        // this.currAmountListSort.sort((a,b)=>a-b);
                        break;
                    case COMMAND.all_endgame:
                        data.id==this.roomInfo.id&&this.resetAmount("submiting");
                        break;
                    case COMMAND.all_getcurrpoker:
                        // data.poker=[[18],[]]
                        // let len=data.poker.flat(Infinity).length;
                        // if(data.id==this.roomInfo.id&&((!data.isget)||(data.isget&&len>0&&len<3))){//是当前台的数据并且(是推送)(或者主动获取并且只有1~2张牌)
                        if(data.id==this.roomInfo.id&&((!data.isget)||(this.pokerArr.length>0&&String(this.pokerArr[this.pokerArr.length-1])!=String(data.poker)))){//是当前台的数据并且(是推送)(或者与pokerArr最新的一组牌不同，说明还没结束本轮)
                            this.isShowPoker=false;
                            this.isShowPokerCompare=false;
                            this.showPokerArr=data.poker;
                            this.currPokerXY=data.index;
                            this.roomInfo.pokermode==POKER_TYPE.show&&(this.isShowPokerLayer=true);
                        }
                        //由于明牌台赔率是根据牌动态改变的，所以需要在此获取
                        // this.roomInfo.pokermode==POKER_TYPE.show&&this.$emit("ws-send",COMMAND.bac_getodds,this.roomInfo.id,this.userInfo.id,this.userInfo.guid);
                        this.roomInfo.pokermode==POKER_TYPE.show&&this.$root.wsSendJson({
                            command:COMMAND.bac_getodds,
                            tableId:this.roomInfo.id,
                            userid:this.userInfo.id,
                            guid:this.userInfo.guid
                        });
                        break;
                    case COMMAND.all_settlement:
                        if(data.id==this.roomInfo.id){
                            this.isShowPoker=true;
                            if(this.roomInfo.pokermode==POKER_TYPE.show){//明牌台重置额度
                                this.odds={z:0,x:0,h:0,zd:0,xd:0,z6:0,z26:0,z36:0,x7z6:0}
                            }
                        }
                        break;
                    case COMMAND.all_getgain:
                        if(data.id==this.roomInfo.id){
                            setTimeout(() => {
                                this.resetAmount("all",2);
                            }, 5000);
                            if(data.win!=0||data.lose!=0){
                                useLayer({str:(data.win > Math.abs(data.lose)? this.$t("common.win"):this.$t("common.lose"))+Math.abs(data.win - data.lose)});
                                if(data.win-data.lose>0&&!this.isShowMark){//赢了并且没点开印记界面则显示获得印记效果
                                    this.isShowGetMark=true;
                                    setTimeout(() => {
                                        this.isShowGetMark=false;
                                    }, 2000);
                                }
                            }
                        }
                        break;
                    case COMMAND.bac_receivepool:
                        data.id==this.roomInfo.id&&(this.pool=data.pool);
                        break;
                    case COMMAND.bac_submitbet:
                        switch (data.result) {
                            case SUBMIT_RESULT.success:
                                useLayer({str:this.$t("common.subSuccess")});
                                this.$store.commit({
                                    type:MUTATION_TYPE.setUserInfo,
                                    userInfo:{
                                        realCoin:data.realmoney
                                    }
                                })
                                for (let i in this.submited[this.currRebate]) {//将本次提交的额度追加到已提交的额度中
                                    this.submited[this.currRebate][i]+=this.submiting[i];
                                }
                                //设置提交列表
                                this.$store.commit({
                                    type:MUTATION_TYPE.setCurrBetList,
                                    room:{
                                        game:this.roomInfo.game,
                                        id:this.roomInfo.id,
                                        detail:JSON.parse(JSON.stringify(this.submited)),
                                        winArr:[]
                                    }
                                })
                                this.resetAmount("submiting");//清空将提交额度列表
                                break;
                            case SUBMIT_RESULT.ban:
                                useLayer({str:this.$t("common.subBan")});
                                break;
                            case SUBMIT_RESULT.unmoney:
                                useLayer({str:this.$t("common.unMoney")});
                                break;
                            case SUBMIT_RESULT.countdown:
                                useLayer({str:this.$t("common.subCountdown")});
                                break;
                            case SUBMIT_RESULT.outside:
                                useLayer({str:this.$t("common.unLimit")});
                                break;
                            case SUBMIT_RESULT.service:
                                useLayer({str:this.$t("common.service")});
                                break;
                            case SUBMIT_RESULT.malice:
                                useLayer({str:""});
                                break;
                            default:
                                useLayer({str:this.$t("common.subErr")});
                                break;
                        }
                        break;
                    case COMMAND.all_cancelbet:
                        if(data.result==CANCEL_RESULT.success){
                            this.resetAmount("all",2);
                            this.$store.commit({
                                type:MUTATION_TYPE.setUserInfo,
                                userInfo:{
                                    realCoin:data.realmoney
                                }
                            })
                            useLayer({str:this.$t("common.cancelSuccess")});
                        }else{
                            useLayer({str:this.$t("common.cancelErr")});
                        }
                        break;
                    case COMMAND.all_changeboot:
                        if(data.id==this.roomInfo.id){
                            this.pearlArr=[];
                            this.pokerArr=[];
                            this.$store.commit({
                                type:MUTATION_TYPE.setRoomInfo,
                                roomInfo:{
                                    boot:data.boot,
                                    innings:data.innings
                                }
                            })
                        }
                        this.pearlObj={
                            id:data.id,
                            pearl:[]
                        }
                        this.countList[data.id]=[0,0,0];
                        break;
                    case COMMAND.bac_getbetdetail:
                        if(data.id==this.roomInfo.id){    
                            this.submited=[
                                {
                                    z:Number(data.detail[0].z),
                                    x:Number(data.detail[0].x),
                                    h:Number(data.detail[0].h),
                                    zd:Number(data.detail[0].zd),
                                    xd:Number(data.detail[0].xd),
                                    z6:Number(data.detail[0].z1),
                                    z26:Number(data.detail[0].z2),
                                    z36:Number(data.detail[0].x1),
                                    x7z6:Number(data.detail[0].x2)
                                },{
                                    z:Number(data.detail[1].z),
                                    x:Number(data.detail[1].x),
                                    h:Number(data.detail[1].h),
                                    zd:Number(data.detail[1].zd),
                                    xd:Number(data.detail[1].xd),
                                    z6:Number(data.detail[1].z1),
                                    z26:Number(data.detail[1].z2),
                                    z36:Number(data.detail[1].x1),
                                    x7z6:Number(data.detail[1].x2)
                                }
                            ]
                        }
                        break;
                    case COMMAND.all_entertable:
                        this.isShowPoker=true;
                        this.showPokerArr=[];
                        this.$root.$refs.startAudioPlayer.pause();
                        this.$root.$refs.endAudioPlayer.pause();
                        this.$root.$refs.tenAudioPlayer.pause();
                        this.$refs.resultAudioPlayer.pause();
                        this.pokerArr=[];
                        this.isShowPearlMoreLayer=false;
                        this.pearlMoreType=null;
                        this.pool={z:0,x:0,zd:0,xd:0,h:0};
                        // data.iscommission==IS_REBATE.false&&(this.currRebate=REBATE_TYPE.rebate);//不能免佣则重置佣金模式为非免佣
                        this.init();
                        this.resetAmount("submiting");
                        break;
                    case COMMAND.bac_getroompoker:
                        this.pokerArr=[];//防止断线重连后数据叠加
                        let arr=data.list;
                        for (let i = 0; i < arr.length; i++) {
                            // arr[i].zp.length>0&&arr[i].xp.length>0&&
                            this.pokerArr.push([arr[i].zp,arr[i].xp]);
                        }
                        if(this.roomInfo.pokermode==POKER_TYPE.show){//明牌台需要获取牌，放在这是确保pokerArr有值
                            // this.$emit("ws-send",COMMAND.all_getcurrpoker,this.roomInfo.game, this.roomInfo.id, this.userInfo.id,this.userInfo.guid);
                            this.$root.wsSendJson({
                                command:COMMAND.all_getcurrpoker,
                                game:this.roomInfo.game,
                                tableId:this.roomInfo.id,
                                userid:this.userInfo.id,
                                guid:this.userInfo.guid
                            });
                        }
                        break;
                    case COMMAND.bac_gameresult:
                        if(data.id==this.roomInfo.id){
                            this.currPokerXY=[0,0];
                            this.updatePearl(this.pearlArr,data.pearl);
                            this.setCoruscate(data.pearl,data.zpoker,data.xpoker);
                            this.isShowPokerCompare=true;
                            if(data.zpoker.length>0&&data.xpoker.length>0){//有牌
                                this.showPokerArr=[data.zpoker,data.xpoker];
                                this.pokerArr.push(this.showPokerArr);
                                setTimeout(() => {
                                    this.showPokerArr=[];
                                }, 5000);
                            }
                        }
                        break;
                    
                    case COMMAND.all_startgame:
                        if(data.id==this.roomInfo.id){
                            this.roomInfo.pokermode==POKER_TYPE.show&&(this.isShowPokerLayer=false);
                        }
                        break;
                }
            }
        },
        /**
         * 设置窗口大小改变
         */
        setResize(){
            this.drawPearl(this.pearlArr);
            this.drawMorePearl(this.pearlMoreType);
        },
        /**
         * 设置闪烁位
         */
        setCoruscate(pearl,zpokerArr,xpokerArr,fn){
            let arr=[];
            pearl=pearl.substr(0,1);
            let zpoker=zpokerArr.reduce((prev,val)=>prev+(Math.ceil(val/4)>9?0:Math.ceil(val/4)),0);
            let xpoker=xpokerArr.reduce((prev,val)=>prev+(Math.ceil(val/4)>9?0:Math.ceil(val/4)),0);
            if(PEARL_CODE.Z.indexOf(pearl) != -1){
                arr.push('z');

                //判断6点
                if(zpoker>xpoker&&zpoker==6){
                    if(zpokerArr.length==2){
                        arr.push('z26');
                    }else if(zpokerArr.length==3){
                        arr.push('z36');
                    }
                    arr.push('z6');
                }

                this.$refs.resultAudioPlayer.currentPlayIndex=(this.roomInfo.game==GAME_ID.bac?4:2);
                this.$nextTick(()=>{
                    this.$refs.resultAudioPlayer.play();
                })
            }else if(PEARL_CODE.X.indexOf(pearl) != -1){
                arr.push('x');
                if(zpoker==6&&xpoker==7){
                    arr.push('x7z6');
                }
                this.$refs.resultAudioPlayer.currentPlayIndex=(this.roomInfo.game==GAME_ID.bac?3:1);
                this.$nextTick(()=>{
                    this.$refs.resultAudioPlayer.play();
                })
            }else if(PEARL_CODE.H.indexOf(pearl) != -1){
                arr.push('h');
                this.$refs.resultAudioPlayer.currentPlayIndex=0;
                this.$nextTick(()=>{
                    this.$refs.resultAudioPlayer.play();
                })
            }
            PEARL_CODE.ZD.indexOf(pearl) != -1 && arr.push('zd');
            PEARL_CODE.XD.indexOf(pearl) != -1 && arr.push('xd');
            this.coruscateArr=arr;
            setTimeout(() => {
                this.coruscateArr=[];
                fn&&fn();
            }, 5000);
        },
        /**
         * 设置当前佣金模式
         */
        setRebate(e){
            if(this.roomInfo.iscommission==IS_REBATE.false){//不能免佣
                useLayer({str:this.$t("video.noChangeRebate")});
                e.target.checked=false;
            }else{//可以免佣
                let fn=()=>{
                    if(this.currRebate==REBATE_TYPE.rebate){
                        this.currRebate=REBATE_TYPE.noRebate;
                    }else if(this.currRebate==REBATE_TYPE.noRebate){
                        this.currRebate=REBATE_TYPE.rebate;
                    }
                    this.resetAmount("submiting");
                    //获取各位置已提交额度
                    // this.$emit("ws-send",COMMAND.bac_getbetdetail,this.roomInfo.id,this.roomInfo.boot,this.roomInfo.innings,this.userInfo.id,this.userInfo.guid);
                    this.$root.wsSendJson({
                        command:COMMAND.bac_getbetdetail,
                        tableId:this.roomInfo.id,
                        boot:this.roomInfo.boot,
                        innings:this.roomInfo.innings,
                        userid:this.userInfo.id,
                        guid:this.userInfo.guid
                    })
                }
                if(this.getAmountCount("submiting")!=0){//有未提交的额度
                    e.target.checked=!e.target.checked;
                    useLayer({
                        type:LAYER_TYPE.confirm,
                        str:this.$t("room.isChangeRebate"),
                        btn:[this.$t("common.yes"),this.$t("common.no")],
                        yesFn:(i)=>{
                            fn();
                            layer.close(i);
                        }
                    });
                }else{//没有未提交的项
                    fn();
                }
            }
        },
        /**
         * 提交事件
         */
        submitEvent(event){
            switch (event) {
                case "clear"://点击清除
                    this.getAmountCount("submiting")!=0&&this.resetAmount("submiting");
                    break;
                case "cancel"://点击取消
                    if(this.canCancel){
                        useLayer({
                            type:LAYER_TYPE.confirm,
                            str:this.$t("common.isCancel"),
                            btn:[this.$t("common.yes"),this.$t("common.no")],
                            yesFn:(i)=>{
                                layer.close(i);
                                // this.$emit("ws-send",COMMAND.all_cancelbet,this.roomInfo.game,this.roomInfo.id,this.roomInfo.boot,this.roomInfo.innings,this.userInfo.id,this.userInfo.guid);
                                this.$root.wsSendJson({
                                    command:COMMAND.all_cancelbet,
                                    game:this.roomInfo.game,
                                    tableId:this.roomInfo.id,
                                    boot:this.roomInfo.boot,
                                    innings:this.roomInfo.innings,
                                    userid:this.userInfo.id,
                                    guid:this.userInfo.guid
                                })
                            }
                        })
                    }
                    break;
                case "confirm"://点击确定
                    if(this.canConfirm){
                        // this.$emit("ws-send",COMMAND.bac_submitbet,this.roomInfo.game,this.roomInfo.id,this.roomInfo.boot,this.roomInfo.innings,
                        //     this.getAmountCount("submiting"),this.getAmountCount("submiting")+this.getAmountCount("submited",REBATE_TYPE.rebate)+this.getAmountCount("submited",REBATE_TYPE.noRebate),this.currRebate,
                        //     String(this.submiting.z)+","+String(this.submiting.x)+","+String(this.submiting.h)+","+String(this.submiting.zd)+","+String(this.submiting.xd)+","+String(this.submiting.z6)+","+String(this.submiting.z26)+","+String(this.submiting.z36)+","+String(this.submiting.x7z6),
                        //     this.userInfo.id,this.$root.ip.cip,getDeviceType(),this.userInfo.guid);
                        this.$root.wsSendJson({
                            command:COMMAND.bac_submitbet,
                            game:this.roomInfo.game,
                            tableId:this.roomInfo.id,
                            boot:this.roomInfo.boot,
                            innings:this.roomInfo.innings,
                            currAmount:this.getAmountCount("submiting"),
                            totalAmount:this.getAmountCount("submiting")+this.getAmountCount("submited",REBATE_TYPE.rebate)+this.getAmountCount("submited",REBATE_TYPE.noRebate),
                            isUnComm:this.currRebate,
                            order:String(this.submiting.z)+","+String(this.submiting.x)+","+String(this.submiting.h)+","+String(this.submiting.zd)+","+String(this.submiting.xd)+","+String(this.submiting.z6)+","+String(this.submiting.z26)+","+String(this.submiting.z36)+","+String(this.submiting.x7z6),
                            userid:this.userInfo.id,
                            ip:this.$root.ip.cip,
                            loginType:getDeviceType(),
                            guid:this.userInfo.guid
                        })
                    }
                    break;
                case "multiple"://点击多台
                    this.isMultiple=!this.isMultiple;//变换模式
                    if(this.tabGame!=GAME_ID.bac){//当前选项卡选中别的游戏则需要重新获取台列表
                        this.roomList=[];
                        if(!this.isMultiple){//非多台，重绘路单
                            this.$nextTick(()=>{
                                this.pearlArr=JSON.parse(JSON.stringify(this.pearlArr));
                            })
                        }
                        // this.$emit("ws-send",COMMAND.all_getroomlist, this.isMultiple?this.roomInfo.game:this.tabGame,this.userInfo.id, this.userInfo.guid);
                        this.$root.wsSendJson({
                            command:COMMAND.all_getroomlist,
                            game:this.isMultiple?this.roomInfo.game:this.tabGame,
                            userid:this.userInfo.id,
                            guid:this.userInfo.guid
                        })
                    }
                    break;
            }
        },
        /**
         * 为位置追加将要提交的额度
         * @param {String} type 位置类型(z、x、h、zd、xd)
         */
        addAmount(type,event){
            let limitred=this.limitred[type].split('-');//获取限红
            let amount=this.amount;
            if(!this.odds[type]){
                useLayer({str:this.$t("room.odds0")});
                return;
            }
            if(this.roomInfo.countdown<=0){
                useLayer({str:this.$t("room.noStartGame")});
                return;
            }else if(amount!=Infinity&&this.userInfo.realCoin<this.getAmountCount("submiting")+amount){//余额不足
                useLayer({str:this.$t("common.unMoney")});
                return;
            }
            if(amount!=Infinity){//非满额度
                if(amount>limitred[1]){//单次高于上限
                    useLayer({str:this.$t("room.higherLimitred")+limitred[1]});
                    return;
                }else if(this.submiting[type]+this.submited[this.currRebate][type]+amount>limitred[1]){//多次并高于上限
                    useLayer({str:this.$t("room.laveLimitred")+(limitred[1]-this.submiting[type]-this.submited[this.currRebate][type])});
                    return;
                }
            }else{//满额度
                amount=limitred[1]-this.submiting[type]-this.submited[this.currRebate][type];//计算位置还能加多少额度
                if(amount<=0){
                    useLayer({str:this.$t("room.fullAmount")});
                    return;
                }
                if(this.userInfo.realCoin<amount){//余额不够加满
                    amount=this.userInfo.realCoin;//则有多少余额就加多少
                }
            }
            this.submiting[type]=this.submiting[type]+amount;
            if(event){
                this.isScaleAmount[type]=true;
                setTimeout(() => {
                    this.isScaleAmount[type]=false;
                }, 120);
            }
        },
        /**
         * 获取额度
         * @param {String} type 额度类型(submited、submiting、all)
         * @param {Number} rebate 免佣类型(0:非免佣 1:免佣 2:免佣+非免佣)
         */
        getAmountCount(type,rebate){
            let count=0;
            if(type=="submiting"||type=="all"){//预投或总投
                for (let i in this.submiting) {
                    count+=this.submiting[i];
                }
            }
            if(type=="submited"||type=="all"){//已投或总投
                if(rebate==REBATE_TYPE.rebate||rebate==2){//累计非免佣
                    for (let i in this.submited[REBATE_TYPE.rebate]) {
                        count+=this.submited[REBATE_TYPE.rebate][i];
                    }
                }
                if(rebate==REBATE_TYPE.noRebate||rebate==2){//累计免佣
                    for (let i in this.submited[REBATE_TYPE.noRebate]) {
                        count+=this.submited[REBATE_TYPE.noRebate][i];
                    }
                }
            }
            return count;
        },
        /**
         * 将下单信息的值折成百分比
         * @param {Number} number 要计算成百分比的下单信息
         */
        getAmountCountPercent(number){
            let total=this.getAmountCount("submiting")+this.getAmountCount("submited",REBATE_TYPE.rebate)+this.getAmountCount("submited",REBATE_TYPE.noRebate);
            if(total==0){
                return "0%";
            }else{
                return (number/total*100).toFixed(2)+"%";
            }
        },
        /**
         * 重置额度
         * @param {String} type 额度类型(submited、submiting、all)
         * @param {Number} rebate 免佣类型(0:非免佣 1:免佣 2:免佣+非免佣)
         */
        resetAmount(type,rebate){
            if(type=="submiting"||type=="all"){//预投或总投
                for (let i in this.submiting) {
                    this.submiting[i]=0;
                }
            }
            if(type=="submited"||type=="all"){//已投或总投
                if(rebate==REBATE_TYPE.rebate||rebate==2){//重置非免佣
                    for (let i in this.submited[REBATE_TYPE.rebate]) {
                        this.submited[REBATE_TYPE.rebate][i]=0;
                    }
                }
                if(rebate==REBATE_TYPE.noRebate||rebate==2){//重置免佣
                    for (let i in this.submited[REBATE_TYPE.noRebate]) {
                        this.submited[REBATE_TYPE.noRebate][i]=0;
                    }
                }
            }
        },
        /**
         * 问路
         */
        nextPrediction(pearl){
            if(!this.isShowNextPrediction){//当前没有在显示问路，防止多次点击
                this.isShowNextPrediction=true;
                let virtualArr=JSON.parse(JSON.stringify(this.pearlArr));//深克隆一个虚拟数组
                this.updatePearl(virtualArr,pearl);
                this.drawPearl(virtualArr);
                this.nextPredictionTimer = setTimeout(() => {
                    this.drawPearl(this.pearlArr);
                    this.isShowNextPrediction=false;
                }, 1000);
            }
        },
        /**
		 * 更新路单信息
		 * @param {Array} pearlArr 路单列表
		 * @param {String} pearl 路单数据
		 */
		updatePearl(pearlArr,pearl){
			if (pearlArr && pearlArr.length > 0 && (
				(PEARL_CODE.Z.indexOf(pearl.substr(0, 1)) != -1 && PEARL_CODE.Z.indexOf(pearlArr[pearlArr.length - 1][0].substr(0, 1)) != -1) ||
				(PEARL_CODE.X.indexOf(pearl.substr(0, 1)) != -1 && PEARL_CODE.X.indexOf(pearlArr[pearlArr.length - 1][0].substr(0, 1)) != -1) ||
				(PEARL_CODE.H.indexOf(pearl.substr(0, 1)) != -1 && PEARL_CODE.H.indexOf(pearlArr[pearlArr.length - 1][0].substr(0, 1)) != -1)
				)) {//如果当前的露珠类型与上一项同类，则加到上一项的队列中
				pearlArr[pearlArr.length - 1].push(pearl);
			} else {//否则新建自己的队列
				pearlArr.push([pearl]);
			}
		},
        /**
         * 绘制路单
         */
        drawPearl(pearlArr){
            if(!this.isMultiple){//非多台
                //画表格
                let elemList = document.querySelectorAll("[data-canvas-room]");
                for (let elem of elemList){
                    let val=elem.dataset.canvasRoom;//获取data-canvas-room属性的值
                    //设置画布大小
                    this.$root.setCanvasSize(elem);
                    //绘制画布表格
                    let obj = this.$root.drawCanvasTable(elem,val,false);
                    if(obj){//判断对象是否存在，防止视口被拉小到没有的时候找不到而报错
                        if(obj.elem.id=='textBigPearl'){
                            //设置移入带字大路区的遮罩层大小
                            this.pearlLayerStyle.width=obj.cellWidth/RATIO+'px';
                            this.pearlLayerStyle.height=obj.cellHeight/RATIO+'px';
                        }
                        //画路单
                        if(pearlArr.length>0){
                            var delTieArr=this.$root.setPearlData(this.roomInfo.game,pearlArr,Infinity,false);//第一次调用setPearlData是为了去掉和，此时并无法确定要保留多少列
                            if(obj.elem.id=="textBigPearl"){
                                let countArr= this.$root.drawOrderPearl(obj,pearlArr,PEARL_TYPE.big_text);
                                this.pearlCount.z=countArr[0];
                                this.pearlCount.x=countArr[1];
                                this.pearlCount.h=countArr[2];
                                this.pearlCount.zd=countArr[3];
                                this.pearlCount.xd=countArr[4];
                            }else if(obj.elem.id=="threePearl"){
                                this.$root.drawOrderPearl(obj,pearlArr,PEARL_TYPE.big_three);
                            }else if(obj.elem.id=="bigPearl"){
                                this.$root.drawPearl(obj,this.$root.setPearlData(this.roomInfo.game,pearlArr,obj.column-1,false),PEARL_TYPE.big_hollow,GAME_ID.bac);
                            }else if(obj.elem.id=="smallHollowPearl"){
                                this.$root.drawPearl(obj,
                                    this.$root.setPearlData(this.roomInfo.game,this.$root.convertToSmallPearl(delTieArr,PEARL_TYPE.small_hollow),obj.column*2-1,false),//第二次调用setPearlData是为了保留多少列
                                    PEARL_TYPE.small_hollow,GAME_ID.bac);
                            }else if(obj.elem.id=="smallSolidPearl"){
                                this.$root.drawPearl(obj,
                                    this.$root.setPearlData(this.roomInfo.game,this.$root.convertToSmallPearl(delTieArr,PEARL_TYPE.small_solid),obj.column*2-1,false),//第二次调用setPearlData是为了保留多少列
                                    PEARL_TYPE.small_solid,GAME_ID.bac);
                            }else if(obj.elem.id=="bevelPearl"){
                                this.$root.drawPearl(obj,
                                    this.$root.setPearlData(this.roomInfo.game,this.$root.convertToSmallPearl(delTieArr,PEARL_TYPE.bevel),obj.column*2-1,false),//第二次调用setPearlData是为了保留多少列
                                    PEARL_TYPE.bevel,GAME_ID.bac);
                            }
                        }
                    }
                }
                //更新下局预测
                if(pearlArr.length>0){
                    if(delTieArr&&delTieArr.length>0){//判断去掉和之后的数组长度大于0，防止第一口为和时报错
                        let lastLetter=delTieArr[delTieArr.length-1][0].substring(0,1);//获取最后一列的第一项的首字母
                        let str;
                        if(PEARL_CODE.Z.indexOf(lastLetter)!=-1){//判断最后一列是Z类
                            //下局z
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-2,-1).concat([delTieArr.slice(-1).flat().concat(lastLetter)]),
                                        PEARL_TYPE.small_hollow
                                    ).flat().slice(-1));
                            this.nextZHollowStyle="color:"+(str?(str=='A'?COLOR.red:COLOR.blue):'#6c757d');//取倒数第二列拼上追加了虚拟项的倒数第一列
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-3,-1).concat([delTieArr.slice(-1).flat().concat(lastLetter)]),
                                        PEARL_TYPE.bevel
                                    ).flat().slice(-1));
                            this.nextZBevelStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'#6c757d');
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-4,-1).concat([delTieArr.slice(-1).flat().concat(lastLetter)]),
                                        PEARL_TYPE.small_solid
                                    ).flat().slice(-1));
                            this.nextZSolidStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'#6c757d');
                            //下局x
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-2).concat([['B']]),
                                        PEARL_TYPE.small_hollow
                                    ).flat().slice(-1));
                            this.nextXHollowStyle="color:"+(str?(str=='A'?COLOR.red:COLOR.blue):'#6c757d');//取倒数第二列拼上追加了虚拟项的倒数第一列
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-3).concat([['B']]),
                                        PEARL_TYPE.bevel
                                    ).flat().slice(-1));
                            this.nextXBevelStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'#6c757d');
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-4).concat([['B']]),
                                        PEARL_TYPE.small_solid
                                    ).flat().slice(-1));
                            this.nextXSolidStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'#6c757d');
                        }else if(PEARL_CODE.X.indexOf(lastLetter)!=-1){//X类
                            //下局z
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-2).concat([['A']]),
                                        PEARL_TYPE.small_hollow
                                    ).flat().slice(-1));
                            this.nextZHollowStyle="color:"+(str?(str=='A'?COLOR.red:COLOR.blue):'#6c757d');//取倒数第二列拼上追加了虚拟项的倒数第一列
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-3).concat([['A']]),
                                        PEARL_TYPE.bevel
                                    ).flat().slice(-1))
                            this.nextZBevelStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'#6c757d');
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-4).concat([['A']]),
                                        PEARL_TYPE.small_solid
                                    ).flat().slice(-1));
                            this.nextZSolidStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'#6c757d');
                            //下局x
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-2,-1).concat([delTieArr.slice(-1).flat().concat(lastLetter)]),
                                        PEARL_TYPE.small_hollow
                                    ).flat().slice(-1));
                            this.nextXHollowStyle="color:"+(str?(str=='A'?COLOR.red:COLOR.blue):'#6c757d');//取倒数第二列拼上追加了虚拟项的倒数第一列
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-3,-1).concat([delTieArr.slice(-1).flat().concat(lastLetter)]),
                                        PEARL_TYPE.bevel
                                    ).flat().slice(-1));
                            this.nextXBevelStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'#6c757d');
                            str=String(this.$root.convertToSmallPearl(
                                        delTieArr.slice(-4,-1).concat([delTieArr.slice(-1).flat().concat(lastLetter)]),
                                        PEARL_TYPE.small_solid
                                    ).flat().slice(-1));
                            this.nextXSolidStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'#6c757d');
                        }
                    }
                }else{
                    this.pearlCount={z:0,x:0,h:0,zd:0,xd:0};//清空统计
                    this.nextZHollowStyle="color:#6c757d";
                    this.nextZBevelStyle="background:#6c757d";
                    this.nextZSolidStyle="background:#6c757d";
                    this.nextXHollowStyle="color:#6c757d";
                    this.nextXBevelStyle="background:#6c757d";
                    this.nextXSolidStyle="background:#6c757d";
                }
            }
        },
        /**
         * 显示牌
         * @param {Number} type 移入或移出
         */
        showPoker(e,type){
            if(this.pearlLayerStyle.width!=0&&this.pearlLayerStyle.height!=0){//避免页面未加载完时鼠标移入路区报错
                if(type==1){//移入
                    if(this.isShowPoker){
                        let cellWidth=this.pearlLayerStyle.width.replace('px','');
                        let cellHeight=this.pearlLayerStyle.height.replace('px','');
                        let column=(getComputedStyle(e.target).width.replace('px','')/cellWidth).toFixed();//获取总列数
                        let x = Math.ceil(e.offsetX / cellWidth);//列
                        let y = Math.ceil(e.offsetY / cellHeight);//行
                        let array=this.pearlArr.flat(Infinity);
                        let pokerArr=this.pokerArr.slice(-(column - 1) * 6 - array.length % 6);//取倒数的数据
                        let poker=pokerArr[(x-1)*6+(y-1)];//获取对应位置的扑克
                        if((x!=this.point[0]||y!=this.point[1])&&x!=0&&y!=0&&poker&&poker.flat(Infinity).length>0){//坐标点相比于上次有不同并且大于0行0列并且对应位置有扑克数据
                            this.point=[x,y];
                            this.$nextTick(()=>{
                                this.pearlLayerStyle.display='block';
                                this.pearlLayerStyle.left=(x-1)*cellWidth+'px';
                                this.pearlLayerStyle.top=(y-1)*cellHeight+'px';
                                this.showPokerArr=poker;
                                this.showPokerTimer&&clearTimeout(this.showPokerTimer);
                                this.showPokerTimer = setTimeout(() => {
                                    this.showPokerArr=[];
                                }, 5000);
                                this.roomInfo.pokermode==POKER_TYPE.show&&(this.isShowPokerLayer=true);
                            })
                        }else{
                            this.showPokerArr=[];
                            this.pearlLayerStyle.display='none';
                            this.point=[0,0];
                        }
                    }
                }else{//移出
                    this.showPokerArr=[];
                    this.pearlLayerStyle.display='none';
                    this.point=[0,0];
                    this.showPokerTimer&&clearTimeout(this.showPokerTimer);
                }
            }
        },
        /**
         * 根据牌获取点数
         */
        getPoint(pokerArr){
            if(this.roomInfo.game==GAME_ID.bac){
                return pokerArr.reduce((prev,val)=>prev+(Math.ceil(val/4)>10?10:Math.ceil(val/4)),0)%10||0;
            }else{
                return pokerArr.reduce((prev,val)=>prev+Math.ceil(val/4),0)||0;
            }
        },
        /**
         * 牌是否赢
         */
        isPokerWin(index){
            if(this.roomInfo.game==GAME_ID.bac){
                let sumArr = this.showPokerArr.map(v=>v.reduce((prev,val)=>prev+(Math.ceil(val/4)>10?10:Math.ceil(val/4)),0)%10);
                return sumArr[index]>sumArr[1-index]?true:false;
            }else{
                let sumArr = this.showPokerArr.map(v=>v.reduce((prev,val)=>prev+Math.ceil(val/4),0));
                return sumArr[index]>sumArr[1-index]||(sumArr[index]==sumArr[1-index]&&this.showPokerArr[index]>this.showPokerArr[1-index])?true:false;//牌大或者牌一样并且花色大
            }
        },
        /**
         * 额度换算
         */
        chipsConvert(amount){
            let arr=[];//最终转换成的额度
            let amountArr = AMOUTN_ARR.slice(0,AMOUTN_ARR.length-1);//取除了梭哈之外的额度
            for (let i = amountArr.length-1; i >= 0; i--) {
                if(amount>=amountArr[i]){
                    let num=Math.floor(amount/amountArr[i]);//获取要换算的额度最多能换到多少个当前遍历到的额度
                    for (let j = 0; j < num; j++) {
                        arr.push(amountArr[i]);
                    }
                    amount-=num*amountArr[i];
                }
            }
            return arr;
        },
        /**
         * 显示全部路单
         * @param {PEARL_TYPE} pearlType 台面id
         */
        showMorePearl(pearlType){
            this.pearlMoreType=pearlType;
            this.$nextTick(()=>{
                this.drawMorePearl(pearlType);
                this.isShowPearlMoreLayer=false;
            })
        },
        /**
         * 绘制全部历史路单
         */
        drawMorePearl(pearlType){
            let obj;
            let elem=document.getElementById("fullPearl");//获取画布元素
            if(elem){
                let style=getComputedStyle(elem);//获取画布样式
                let height=style.height.replace('px','');//获取画布高度
                let width=getComputedStyle(elem.parentElement).width.replace('px','');//获取一版画布的宽度
                let cellHeight=height/6;//单元格高度
                let dataColumn=0;//获取数据需要的列数
                let canvasColumn=Math.round(width / cellHeight);//获取一版画布可以绘制多少列
                let arr;
                if(pearlType==PEARL_TYPE.big_text){
                    dataColumn=Math.ceil(this.pearlArr.flat(Infinity).length/6);
                }else if(pearlType==PEARL_TYPE.big_hollow||pearlType==PEARL_TYPE.small_hollow||pearlType==PEARL_TYPE.small_solid||pearlType==PEARL_TYPE.bevel){
                    arr=this.$root.setPearlData(this.roomInfo.game,this.pearlArr,Infinity,false);//第一次调用setPearlData是为了去掉和，此时并无法确定要保留多少列
                    pearlType!=PEARL_TYPE.big_hollow&&(arr=this.$root.convertToSmallPearl(arr,pearlType));
                    //循环获取拐弯后真实需要占用的列数
                    var maxPoint = [0, 0, 0, 0, 0, 0];//保存每一行露珠达到的最大x坐标点
                    var lastPoint = 0;
                    for (var i = 0; i <arr.length; i++) {//倒序遍历处理后的数组
                        for (var j = 0, currentRow = 0; j < arr[i].length; j++) {
                            if (currentRow == 6 || (i+1) <= maxPoint[currentRow]) {//已经到达最后一行或者当前要画的x坐标小于或等于当前要画行的最大坐标，即当前要画的位置已有露珠
                                if (!(currentRow == 6 && lastPoint < (i+1) - (arr[i].length - 6))) {//如果非(当前已到达第6行并且向左拐不与当前行最大点重叠)，则向右拐
                                    maxPoint[currentRow - 1] = (i+1) + (j - (currentRow-1));//更新最大坐标点为当前个数-当前所在行+当前列=要画的露珠列
                                }
                            } else {//否则向下画
                                currentRow == 5 && (lastPoint = maxPoint[currentRow] == 0 ? 0 : maxPoint[currentRow]);//如果已是最后一行，则保存最大坐标点，用于左拐判断
                                maxPoint[currentRow] = i+1;//更新最大坐标点
                                currentRow++;//累加当前列露珠到达的行数
                            }
                        }
                    }
                    dataColumn=Math.max.apply(null,maxPoint);
                }else if(pearlType==PEARL_TYPE.big_three){
                    dataColumn=Math.ceil(this.pearlArr.flat(Infinity).length/3);
                }
                if(dataColumn<canvasColumn){//如果数据需要的列数比一版画布的列数少，说明一版够用
                    this.$root.setCanvasSize(elem);//设置画布大小
                    elem.style.left="";
                    obj = this.$root.drawCanvasTable(elem,6,false);
                }else{//一版不够展示
                    //加长画布
                    elem.width=dataColumn*cellHeight*RATIO;
                    elem.height=height*RATIO;
                    elem.style.width=dataColumn*cellHeight+"px";
                    // elem.style.height=height+"px";
                    elem.style.left="";
                    elem.style.left=style.left;
                    obj = this.$root.drawCanvasTable(elem,6,false);
                }
                if(pearlType==PEARL_TYPE.big_text||pearlType==PEARL_TYPE.big_three){
                    this.$root.drawOrderPearl(obj,this.pearlArr,pearlType);
                }else if(pearlType==PEARL_TYPE.big_hollow){
                    this.$root.drawPearl(obj,arr,PEARL_TYPE.big_hollow,GAME_ID.bac);
                }else if(pearlType==PEARL_TYPE.small_hollow||pearlType==PEARL_TYPE.small_solid||pearlType==PEARL_TYPE.bevel){
                    this.$root.drawPearl(obj,
                        this.$root.setPearlData(this.roomInfo.game,arr,Infinity,false),//第二次调用setPearlData是为了保留多少列
                        pearlType,GAME_ID.bac,true);
                }
            }
        },
        /**
         * 移动路单
         */
        movePearlMore(type){
            let elem=document.getElementById("fullPearl");//获取画布元素
            let style=getComputedStyle(elem);//获取画布样式
            let left=Number(style.left.replace('px',''));//获取左边距
            let width=Number(getComputedStyle(elem.parentElement).width.replace('px',''));//获取一版画布的宽度
            let fullWidth=Number(style.width.replace('px',''));//获取整个画布宽度
            type==-1&&(elem.style.left=(Math.abs(left)<=width?0:left+width)+"px");//左边剩下的距离只有不够一版画布的宽度则全部显示，大于一版则只显示一版
            //右边剩下的距离(即画布总宽度-左边剩下的距离-一版画布的宽度)只有不够一版的宽度，则左边距设为总宽度-一版宽度,否则说明剩余超出一版宽度则左边距设为左边距-一版宽度
            type==1&&(elem.style.left=(fullWidth-Math.abs(left)-width<=width?-(fullWidth-width):left-width)+"px");
        },
        /**
         * 自动额度选择
         */
        autoAmount(){
            if(this.userAmountList.length==0){//没有选择过额度
                let min=this.limitred.z.split('-')[0];//最低额度
                let max=this.limitred.z.split('-')[1];//最高额度
                // min==0?10:min;//最小额度默认值
                // max==0?1000:max;//最大额度默认值
                // let minLen=Math.abs(min).toString().length;//最小值的位数
                // let maxLen=Math.abs(max).toString().length;//最大值的位数
                // let maxFirst=parseInt(Math.abs(max).toString()[0],10);//最大额度的首位
                let arr=[];
                // arr[0][0]=Math.pow(10,minLen-1);//设置第一个额度(最低额度的基数值，即两位数取10，三位数取100)
                // arr[2][0]=(maxFirst>2?1:5)*(Math.pow(10,maxFirst>2?maxLen-1:maxLen-2));//设置第五个额度(2和2以下取位数减一的5字头，即1000或2000取500，3000取1000)
                if(min==20&&max==1000){
                    arr=[[10,50],[100,200],[500]];
                }else if((min==50&&max==10000)||(min==200&&max==10000)||(min==200&&max==20000)||(min==100&&max==20000)){
                    arr=[[50,100],[500,1000],[5000]];
                }else if((min==300&&max==30000)||(min==300&&max==50000)){
                    arr=[[100,500],[1000,5000],[10000]];
                }else if((min==500&&max==80000)||(min==800&&max==100000)||(min==2000&&max==200000)||(min==3000&&max==300000)){
                    arr=[[100,1000],[5000,10000],[20000]];
                }else{
                    arr=[[10,100],[200,500],[1000]];
                }
                // if (max<=1000) {
                //     arr= [[10,20],[50,100],[200]];
                // }else if ((max>1000&&max<=2000)||(max>2000&&max<=5000)) {
                //     arr= [[10,50],[100,500],[1000]];
                // }else if(max>5000&&max<=10000){
                //     arr= [[10,100],[500,1000],[2000]];
                // }else if(max>10000&&max<=20000){
                //     arr= [[10,100],[500,1000],[5000]];
                // }else if(max>20000&&max<=100000){
                //     arr= [[10,100],[1000,5000],[10000]];
                // }else {
                //     arr= [[10,50],[100,500],[1000]];
                // }
                this.$store.commit({
                    type:MUTATION_TYPE.setCurrAmountList,
                    currAmountList:arr
                })
            }
        },
        videoReady(videoId){
            this.readyVideoIdArr.push(videoId);
        },
        /**
         * 将路单统计的值折成百分比
         * @param number 要计算成百分比的值
         */
        getPearlCountPercent(number){
            let total=this.pearlCount.z+this.pearlCount.x+this.pearlCount.h+this.pearlCount.zd+this.pearlCount.xd;
            if(total>0){
                return ((number/total)*100).toFixed(2)+"%";
            }else{
                return "0%";
            }
        }
    },
    watch: {
        /**
         * 监听路单数据变化
         */
        pearlArr:{
            handler(newVal){
                this.drawPearl(newVal);
                this.drawMorePearl(this.pearlMoreType);
            },
            deep:true//深度监听
        },
        /**
         * 监听视频线路id改变
         */
        currVideoLine(newVal,oldVal){
            if(newVal!=""){
                if(newVal&&this.lastVideoLine!=newVal){
                    //获取台面视频
                    // this.$emit("ws-send",COMMAND.all_getvideo,this.roomInfo.id,newVal,this.userInfo.id,this.userInfo.guid);
                    this.$root.wsSendJson({
                        command:COMMAND.all_getvideo,
                        tableId:this.roomInfo.id,
                        lineId:newVal,
                        userid:this.userInfo.id,
                        guid:this.userInfo.guid
                    })
                    this.lastVideoLine=newVal;
                }
            }else{
                this.videoList=null;
            }
        },
        /**
         * 监听将要提交的额度变化
         */
        submiting:{
            handler(){
                if(this.getAmountCount("submiting")<=0||this.roomInfo.countdown<=0){
                    this.canClear=false;
                    this.canConfirm=false;
                }else{
                    this.canClear=true;
                    this.canConfirm=true;
                }
            },
            deep:true
        },
        /**
         * 监听已提交过的额度变化
         */
        submited:{
            handler(){
                if(this.getAmountCount("submited",this.currRebate)<=0||this.roomInfo.countdown<=0){
                    this.canCancel=false;
                }else{
                    this.canCancel=true;
                }
            },
            deep:true
        },
        /**
         * 监听路单模式改变
         */
        pearlModel(){
            this.$nextTick(()=>{
                this.drawPearl(this.pearlArr);
                this.drawMorePearl(this.pearlMoreType);
            })
        },
        /**
         * 监听guid改变（断线重连）
         */
        "userInfo.guid"(newVal,oldVal){
            if(newVal!=oldVal&&newVal!=""){
                // //获取视频线路
                // this.$emit('ws-send',COMMAND.all_getline,this.userInfo.id, this.userInfo.guid);
                this.init();
            }
        },
        "roomInfo.countdown"(newVal){
            if(newVal==0){
                this.canCancel=false;
                this.canConfirm=false;
            }
        },
        readyVideoIdArr(val){
            console.log(val+"------------------------------------");
        }
    },
};
</script>